import React, { useState, useRef, useEffect, Fragment, useContext } from "react";
import Checkbox_v2 from "../../stories/components/Checkbox_v2";
import ServiceOptionsV2 from "../../stories/components/service_options_v2/ServiceOptionsV2";
import ServiceDetailsV2, { ServiceDetailsSelectArrow } from "../../stories/components/service_details_v2/ServiceDetailsV2";
import AddressV2 from "../../stories/components/address_v2/AddressV2";
import CrossDockFormV2 from "../../stories/components/cross_dock_v2/CrossDockFormV2";
import { Form, Row, Col, DatePicker, Icon, Input, Tooltip, Modal, TimePicker } from "antd";
import SearchAddress_v2 from "../../stories/components/SearchAddress_v2";
import _, { isEmpty, set } from "lodash";
import Text from "antd/lib/typography/Text";
import I18n from "../../common/I18n";
import ReusableInput from "../../stories/components/ReusableInput";
import DeliveryTruckIcon from "../../../assets/images/Delivery.svg";
import Location from "../../../assets/images/Location_v2.svg";
import EditPen from "../../../assets/images/editPenn.svg";
import closeSvg from "../../../assets/images/Close.svg";
import Select_v2 from "../../stories/components/Select_v2";
import {
    getLabelDescriptionForLocation,
    getOrderTypeIconForLocation,
    renderNotification,
} from "./OrderTypeIcons";
import ReusableDatePicker from "../../stories/components/ReusableDatePicker";
import SectionCard from "../../stories/components/SectionCard";
import MobileInput_v2 from "../common/ReusableMobileInput";
import CreateOrderAccessorial from "../../stories/components/CreateOrderAccessorial";
import { checkServiceExistance, formamtAddressType,formatFullName, formatLocationName, removeUnnecessaryCommas, renderAlertMessage } from "../../helpers/common";
import { deferFocus } from "../../helpers/focusUtils";
import { isAppointmentMandatoryOrg } from "../../helpers/appointmentOrgConfig";
import { showLtlOnHandFields } from "../../helpers/orders";
import ModalComponent from "../../stories/components/Modal_v2";
import AppConfig from "../../config/AppConfig";
import MaterialTimePicker from "./MaterialTimePicker";
import { getValueFromArrayOfObjects } from "../../helpers/array_functions";
import { fetchAvailableDates, proccedWithWh, verifyBillingZone, verifyWhbasedZipCodes, fetchZipcodeCheck } from "../../api/OrdersApi";
import { alertMessage, ellipseText, isBetweenDates } from "../../common/Common";
import AntDTimePicker from "./AntDTimePicker";
import { checkIsFilled } from "../../helpers/order_managemnt";
import AddressForm_v2, { AddAddressForm } from "../common/AddressForm_v2";
import AppointmentWindow from "./AppointmentWindow";
import PropTypes from "prop-types";
import { setAccessorialResponse } from "../../helpers/orders";
import "./AddressLocationDetails.scss";
import Button_v2 from "../../stories/components/Button_v2";
import CommercialIcon from "../../../assets/images/Commercial.svg"
import LocCodeIcon from "../../../assets/images/LocCode.svg"
import MailIcon from "../../../assets/images/EmailIcon.svg"
import PhoneIcon from "../../../assets/images/PhoneIcon.svg"
import DisplayTime from "../common/DisplayTime";
import { ChevronRightIcon, PreplanIcon } from "../../common/CustomIcon";
import moment from "moment";

import InfoTooltip from "../../stories/components/InfoTooltip";
import { ZipCodeWhModal } from "./zipCodeWhModal";
import { generalizedverifyWarehouseZipCodes, validateCompanyName } from "./helpers";
import { UserContext } from "../../context/UserContext";
import DisableWrapper from "../../stories/components/DisableWrapper";

const VALID_SECONDARY_LOC_TYPES = ["YARD", "DEPOT", "PORT", "OTHERS"];
const normalizeSecondaryLocType = (value) => {
  const normalized = (value || "").toUpperCase();
  return VALID_SECONDARY_LOC_TYPES.includes(normalized) ? normalized : "OTHERS";
};

// Collapsed leg-summary icons — exact 16x16 glyphs exported from the Figma
// design system (Order Management, node 3689-31631) so the summary card matches
// the prototype 1:1. Rendered with fill=currentColor at the design icon color.
const CARD_ICON_COLOR = "#8AA5B9";
const CARD_GLYPHS = {
  building: "M1.83398 2C1.70138 2.00001 1.57421 2.0527 1.48045 2.14646C1.38668 2.24023 1.334 2.3674 1.33398 2.5V13.5C1.334 13.6326 1.38668 13.7598 1.48045 13.8535C1.57421 13.9473 1.70138 14 1.83398 14H10.1673C10.1882 13.9996 10.2091 13.9978 10.2298 13.9948C10.2518 13.998 10.274 13.9997 10.2962 14H14.1673C14.2999 14 14.4271 13.9473 14.5209 13.8535C14.6146 13.7598 14.6673 13.6326 14.6673 13.5V5.16667C14.6673 5.03406 14.6146 4.90689 14.5209 4.81313C14.4271 4.71936 14.2999 4.66668 14.1673 4.66667H10.6673V2.5C10.6673 2.3674 10.6146 2.24023 10.5209 2.14646C10.4271 2.0527 10.2999 2.00001 10.1673 2H1.83398ZM2.33398 3H9.66732V13H2.33398V3ZM4.00065 4.66667V6H5.33398V4.66667H4.00065ZM6.66732 4.66667V6H8.00065V4.66667H6.66732ZM10.6673 5.66667H13.6673V13H10.6673V11.3333H12.0007V10H10.6673V8.66667H12.0007V7.33333H10.6673V5.66667ZM4.00065 7.33333V8.66667H5.33398V7.33333H4.00065ZM6.66732 7.33333V8.66667H8.00065V7.33333H6.66732ZM4.00065 10V11.3333H5.33398V10H4.00065ZM6.66732 10V11.3333H8.00065V10H6.66732Z",
  pin: "M8.00065 0.666992C5.42914 0.666992 3.33398 2.76214 3.33398 5.33366C3.33398 7.22063 4.4674 8.85005 5.55143 10.0173C6.63546 11.1845 7.722 11.9157 7.722 11.9157C7.80507 11.9714 7.90296 12.001 8.003 12.0005C8.10305 12.0001 8.20065 11.9696 8.2832 11.9131C8.2832 11.9131 9.3681 11.1714 10.4512 9.99902C11.5342 8.82662 12.6673 7.19963 12.6673 5.33366C12.6673 2.76214 10.5722 0.666992 8.00065 0.666992ZM8.00065 1.66699C10.0318 1.66699 11.6673 3.30251 11.6673 5.33366C11.6673 6.78036 10.7171 8.23657 9.7168 9.31934C8.85689 10.2502 8.22204 10.6784 7.99805 10.8389C7.77369 10.6806 7.14173 10.262 6.2832 9.33757C5.2839 8.2616 4.33398 6.80735 4.33398 5.33366C4.33398 3.30251 5.9695 1.66699 8.00065 1.66699ZM8.00065 4.00033C7.64703 4.00033 7.30789 4.1408 7.05784 4.39085C6.80779 4.6409 6.66732 4.98004 6.66732 5.33366C6.66732 5.68728 6.80779 6.02642 7.05784 6.27647C7.30789 6.52652 7.64703 6.66699 8.00065 6.66699C8.35427 6.66699 8.69341 6.52652 8.94346 6.27647C9.19351 6.02642 9.33398 5.68728 9.33398 5.33366C9.33398 4.98004 9.19351 4.6409 8.94346 4.39085C8.69341 4.1408 8.35427 4.00033 8.00065 4.00033ZM3.52279 9.2998C3.4442 9.2973 3.36614 9.31336 3.29492 9.34668C2.73982 9.59671 2.27298 9.89391 1.92253 10.2568C1.57207 10.6198 1.33398 11.073 1.33398 11.5706C1.33398 12.0896 1.58892 12.5603 1.96549 12.9352C2.34207 13.3101 2.84609 13.6149 3.44596 13.8675C4.64572 14.3727 6.24076 14.667 8.00065 14.667C9.76054 14.667 11.3556 14.3727 12.5553 13.8675C13.1552 13.6149 13.6592 13.3101 14.0358 12.9352C14.4124 12.5603 14.6673 12.0896 14.6673 11.5706C14.6673 11.073 14.4292 10.6198 14.0788 10.2568C13.7283 9.89391 13.2615 9.59671 12.7064 9.34668C12.6464 9.31966 12.5818 9.3047 12.5161 9.30268C12.4504 9.30065 12.3849 9.31158 12.3234 9.33486C12.2619 9.35813 12.2056 9.39329 12.1577 9.43832C12.1098 9.48335 12.0713 9.53738 12.0442 9.59731C12.0172 9.65725 12.0023 9.72192 12.0002 9.78763C11.9982 9.85335 12.0092 9.91881 12.0324 9.9803C12.0557 10.0418 12.0909 10.0981 12.1359 10.146C12.181 10.1939 12.235 10.2324 12.2949 10.2594C12.7685 10.4727 13.1343 10.7171 13.36 10.9508C13.5857 11.1846 13.6673 11.3836 13.6673 11.5706C13.6673 11.7687 13.5776 11.9805 13.3301 12.2269C13.0826 12.4733 12.6834 12.7283 12.1673 12.9456C11.1352 13.3803 9.64676 13.667 8.00065 13.667C6.35454 13.667 4.86606 13.3803 3.83398 12.9456C3.31794 12.7283 2.91871 12.4733 2.67122 12.2269C2.42373 11.9805 2.33398 11.7687 2.33398 11.5706C2.33398 11.3836 2.41557 11.1846 2.64128 10.9508C2.86699 10.7171 3.23282 10.4727 3.70638 10.2594C3.81126 10.2146 3.89765 10.1352 3.95122 10.0345C4.00478 9.93377 4.0223 9.81776 4.00086 9.70572C3.97943 9.59368 3.92033 9.49233 3.83337 9.4185C3.74641 9.34467 3.63682 9.30278 3.52279 9.2998Z",
  user: "M8 1.32812C4.32329 1.32812 1.33203 4.31938 1.33203 7.99609C1.33203 11.6728 4.32329 14.6641 8 14.6641C11.6767 14.6641 14.668 11.6728 14.668 7.99609C14.668 4.31938 11.6767 1.32812 8 1.32812ZM8 2.32812C11.1363 2.32812 13.668 4.85982 13.668 7.99609C13.668 9.33778 13.2016 10.5669 12.4258 11.5365C11.6104 10.6082 10.6497 9.87402 9.54688 9.38151L9.45052 9.33854H6.55599L6.45833 9.38151C5.35313 9.87461 4.39187 10.6103 3.57682 11.5404C2.79929 10.5703 2.33203 9.33946 2.33203 7.99609C2.33203 4.85982 4.86373 2.32812 8 2.32812ZM7.9974 4.66797C7.2614 4.66797 6.66276 5.2653 6.66276 6.0013C6.66276 6.11597 6.66276 6.55264 6.66276 6.66797C6.66276 7.40397 7.26009 8.0013 7.99609 8.0013C8.73209 8.0013 9.33073 7.40397 9.33073 6.66797C9.33073 6.55397 9.33073 6.11797 9.33073 6.0013C9.33073 5.2653 8.7334 4.66797 7.9974 4.66797ZM6.79297 10.3385H9.21224C10.1756 10.7822 11.0137 11.4257 11.7318 12.2591C10.7352 13.1317 9.43236 13.6641 8 13.6641C6.56963 13.6641 5.26818 13.1334 4.27214 12.263C4.98978 11.4284 5.82799 10.7826 6.79297 10.3385Z",
  mail: "M1.83398 2.66699C1.70138 2.66701 1.57421 2.71969 1.48045 2.81345C1.38668 2.90722 1.334 3.03439 1.33398 3.16699V12.8337C1.334 12.9663 1.38668 13.0934 1.48045 13.1872C1.57421 13.281 1.70138 13.3336 1.83398 13.3337H14.1673C14.2999 13.3336 14.4271 13.281 14.5209 13.1872C14.6146 13.0934 14.6673 12.9663 14.6673 12.8337V3.16699C14.6673 3.03439 14.6146 2.90722 14.5209 2.81345C14.4271 2.71969 14.2999 2.66701 14.1673 2.66699H1.83398ZM2.33398 3.66699H13.6673V4.70345L8.00065 8.87923L2.33398 4.70345V3.66699ZM2.33398 5.94564L5.89388 8.56934L2.33398 10.8206V5.94564ZM13.6673 5.94564V10.8206L10.1074 8.56934L13.6673 5.94564ZM6.75846 9.20605L7.70378 9.90267C7.78976 9.96611 7.8938 10.0003 8.00065 10.0003C8.1075 10.0003 8.21154 9.96611 8.29752 9.90267L9.24284 9.20605L13.6673 12.0042V12.3337H2.33398V12.0042L6.75846 9.20605Z",
  phone: "M4.80499 1.33561C4.65487 1.32778 4.50102 1.34819 4.35186 1.39941L3.13572 1.81738C1.77987 2.28268 1.01564 3.75807 1.46124 5.12857C1.97771 6.71529 3.00677 8.94624 5.03025 10.9697C7.05373 12.9932 9.28468 14.0223 10.8714 14.5387C12.2419 14.9843 13.7173 14.2201 14.1826 12.8643L14.6006 11.6481H14.6019C14.8065 11.0512 14.5108 10.3864 13.9313 10.1377L11.6761 9.17024C11.1722 8.95431 10.5838 9.06849 10.1956 9.4567L9.27244 10.3786C8.95537 10.2269 8.22319 9.84235 7.1904 8.80956C6.15762 7.77678 5.77284 7.04436 5.62139 6.72753L6.54327 5.80436C6.93088 5.41674 7.04552 4.82847 6.82973 4.32389L5.86228 2.06998V2.06868C5.67555 1.63369 5.25534 1.35909 4.80499 1.33561ZM4.67608 2.34472C4.78579 2.30705 4.89701 2.3558 4.94301 2.46321L5.91046 4.71712C5.96666 4.84854 5.93663 4.99694 5.83624 5.09732L4.65395 6.28092C4.58454 6.35021 4.53704 6.43838 4.51736 6.53446C4.49769 6.63054 4.50669 6.73028 4.54327 6.82128C4.54327 6.82128 5.06787 8.10109 6.48337 9.5166C7.89888 10.9321 9.17869 11.4567 9.17869 11.4567C9.26968 11.4933 9.36943 11.5023 9.46551 11.4826C9.56159 11.4629 9.64976 11.4154 9.71905 11.346L10.9026 10.1637C11.0038 10.0626 11.152 10.0334 11.2829 10.0895L13.5368 11.057C13.6439 11.1029 13.6933 11.2128 13.6552 11.3239L13.2373 12.54C12.9439 13.3949 12.0335 13.864 11.1813 13.5869C9.704 13.1061 7.62047 12.1459 5.73728 10.2627C3.85409 8.3795 2.89392 6.29597 2.41306 4.81868C2.13599 3.96652 2.60512 3.05605 3.45994 2.76269L4.67608 2.34472Z",
  clock: "M8.00065 1.33301C4.32467 1.33301 1.33398 4.3237 1.33398 7.99967C1.33398 11.6756 4.32467 14.6663 8.00065 14.6663C11.6766 14.6663 14.6673 11.6756 14.6673 7.99967C14.6673 4.3237 11.6766 1.33301 8.00065 1.33301ZM8.00065 2.33301C11.1362 2.33301 13.6673 4.86414 13.6673 7.99967C13.6673 11.1352 11.1362 13.6663 8.00065 13.6663C4.86511 13.6663 2.33398 11.1352 2.33398 7.99967C2.33398 4.86414 4.86511 2.33301 8.00065 2.33301ZM8.31706 3.3265C8.19329 3.33074 8.07549 3.38077 7.98649 3.46688C7.89749 3.553 7.84361 3.66908 7.83529 3.79264L7.50195 7.95931C7.49515 8.04541 7.51077 8.1318 7.54728 8.21006C7.58379 8.28833 7.63995 8.35581 7.71029 8.40592L10.0436 10.0726C10.0967 10.1149 10.1578 10.146 10.2233 10.164C10.2888 10.1819 10.3572 10.1864 10.4245 10.177C10.4917 10.1676 10.5564 10.1447 10.6144 10.1095C10.6725 10.0743 10.7228 10.0277 10.7623 9.97249C10.8018 9.91725 10.8296 9.85456 10.8441 9.78822C10.8585 9.72188 10.8593 9.6533 10.8464 9.58664C10.8335 9.51999 10.8072 9.45666 10.769 9.40051C10.7308 9.34437 10.6816 9.29659 10.6243 9.26009L8.52148 7.75749L8.83268 3.87337C8.83939 3.80255 8.83091 3.7311 8.8078 3.66382C8.78469 3.59653 8.74749 3.53495 8.69869 3.48319C8.64989 3.43143 8.5906 3.39067 8.52479 3.36365C8.45897 3.33663 8.38815 3.32396 8.31706 3.3265Z",
  note: "M2.5 2C2.3674 2.00001 2.24023 2.0527 2.14646 2.14646C2.0527 2.24023 2.00001 2.3674 2 2.5V13.5C2.00001 13.6326 2.0527 13.7598 2.14646 13.8535C2.24023 13.9473 2.3674 14 2.5 14H10.8333C10.8991 14.0002 10.9642 13.9874 11.0249 13.9623C11.0857 13.9373 11.1409 13.9006 11.1875 13.8542L13.8542 11.1875C13.9006 11.1409 13.9373 11.0857 13.9623 11.0249C13.9874 10.9642 14.0002 10.8991 14 10.8333V2.5C14 2.3674 13.9473 2.24023 13.8535 2.14646C13.7598 2.0527 13.6326 2.00001 13.5 2H2.5ZM3 3H13V10H10.5C10.3674 10 10.2402 10.0527 10.1465 10.1465C10.0527 10.2402 10 10.3674 10 10.5V13H3V3ZM5.16667 4.66667C5.10041 4.66573 5.03463 4.67797 4.97315 4.70268C4.91166 4.72738 4.8557 4.76406 4.80852 4.81059C4.76133 4.85711 4.72386 4.91254 4.69829 4.97367C4.67271 5.0348 4.65955 5.1004 4.65955 5.16667C4.65955 5.23293 4.67271 5.29853 4.69829 5.35966C4.72386 5.42079 4.76133 5.47622 4.80852 5.52275C4.8557 5.56927 4.91166 5.60595 4.97315 5.63066C5.03463 5.65536 5.10041 5.6676 5.16667 5.66667H10.8333C10.8996 5.6676 10.9654 5.65536 11.0269 5.63066C11.0883 5.60595 11.1443 5.56927 11.1915 5.52275C11.2387 5.47622 11.2761 5.42079 11.3017 5.35966C11.3273 5.29853 11.3405 5.23293 11.3405 5.16667C11.3405 5.1004 11.3273 5.0348 11.3017 4.97367C11.2761 4.91254 11.2387 4.85711 11.1915 4.81059C11.1443 4.76406 11.0883 4.72738 11.0269 4.70268C10.9654 4.67797 10.8996 4.66573 10.8333 4.66667H5.16667ZM5.16667 7.33333C5.10041 7.3324 5.03463 7.34464 4.97315 7.36934C4.91166 7.39405 4.8557 7.43073 4.80852 7.47725C4.76133 7.52378 4.72386 7.57921 4.69829 7.64034C4.67271 7.70147 4.65955 7.76707 4.65955 7.83333C4.65955 7.8996 4.67271 7.9652 4.69829 8.02633C4.72386 8.08745 4.76133 8.14289 4.80852 8.18941C4.8557 8.23593 4.91166 8.27262 4.97315 8.29732C5.03463 8.32203 5.10041 8.33427 5.16667 8.33333H8.16667C8.23292 8.33427 8.2987 8.32203 8.36019 8.29732C8.42167 8.27262 8.47763 8.23593 8.52482 8.18941C8.572 8.14289 8.60947 8.08745 8.63504 8.02633C8.66062 7.9652 8.67379 7.8996 8.67379 7.83333C8.67379 7.76707 8.66062 7.70147 8.63504 7.64034C8.60947 7.57921 8.572 7.52378 8.52482 7.47725C8.47763 7.43073 8.42167 7.39405 8.36019 7.36934C8.2987 7.34464 8.23292 7.3324 8.16667 7.33333H5.16667ZM11 11H12.6263L11 12.6263V11Z",
};
const CardGlyph = ({ name }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" style={{ flexShrink: 0, color: CARD_ICON_COLOR }}>
    <path d={CARD_GLYPHS[name]} fill="currentColor" />
  </svg>
);

const AddressLocationDetails = (props) => {
    const {
        locObj,
        warehouses,
        selectedWarehouse,
        levelOfServices,
        orderTypeConfig,
        getDataRef,
        multistopLocationRef,
        accountComponentAccessorial,
        showAccessorial = false,
        getFieldDecorator,
        dtiversData,
        config,
        form,
        orgContext,
        currentAccount,
        handleUpdateWhStorage = () => {},
        selectedButton,
        setTargetWarehouse,
        allowAppointment=false,
        actionType = 'create',
        orderResponse,
        handleExpedite,
        updateLocData  = () => {},
        setOutofPreplan = () => {},
        currentPreplan = {},
        currentRoute = {},
        screenMode = "create",
        copyOtherLocation = () => {},
        setSamaAsOther = () => {},
        samaAsOther = false,
        keys = "", msLos = "",
        currentWhCode = null,
        setCurrentWhCode = () => {},
        setOriginCode = () => {},
        setDestinationCode = () => {},
        setCurrentLocType = () => {},
        disableAddressFields = false,
        disableEditLHOrder = false,
        updateOrderDetails = () => { },
        zipcodePLHDcheck = () => { },
        setDeliveryWarehouseID = () => { },
        deliveryWarehouseID = null,
        accInputRef,
        accountConfig = {},
        // Phase 4.1 F1 Mode A: the resolved per-leg service-level tariff for this
        // location, threaded from CreateOrderScreen. Present ONLY in Mode A (order
        // routed from the service-level picker); undefined in Mode B (normal
        // create/edit), where both LOS effects below fall through to their
        // original behavior unchanged.
        serviceLevelLosCode = undefined,
        // (serviceLevelLosId / serviceLevelLosRateSheetId props removed: the leg no
        // longer pins the Standard-sheet tariff. Product rule is account-first — the
        // account's own same-code LOS is the default; see the account-first note where
        // the pin effect used to be, below.)
        // Mode A: lock the per-leg LOS dropdown (read-only) unless the user is
        // permitted to edit it (Order Management > "Update Order Tariff" / OLOS).
        // Computed in CreateOrderScreen; false/undefined in Mode B (editable).
        disableLosEdit = false,
        // Task 5 (combo service-level UI polish): true when the order's selected
        // service level is a combo SL AND this location's resolved leg is NOT the
        // combo leg. The Task 4 backend already forces every non-combo leg's
        // los_code to NONE server-side; this only makes that visible/expected in
        // the UI by replacing the editable tariff dropdown with a disabled
        // "Rated via Combo" control. The combo leg itself (comboLegLocked=false)
        // keeps the normal editable Select. False/undefined by default so both
        // Mode B and non-combo Mode A orders render byte-identical to before.
        comboLegLocked = false
    } = props;
    const { orgSettings, currentOrg } = orgContext;
    const { setFieldsValue } = form
  const { orgRules, currentOrg: userCurrentOrg } = useContext(UserContext);
  const closeModelOnSelection = orgRules?.org_billing_rules?.close_address_details_model_when_web_address_selected === 'true';
  const isOrgSpecific = isAppointmentMandatoryOrg(currentOrg?.code);
  const showOnHandFields = showLtlOnHandFields(
    currentOrg || userCurrentOrg,
    orderTypeConfig?.code || orderTypeConfig?.extraCode || orderResponse?.type_of_order
  );
  const [location, setLocation] = useState({
    ...locObj,
    pickup_special: locObj.type_of_loc === "PICKUP" ? locObj.special : false,
    delivery_special: locObj.type_of_loc === "DELIVERY" ? locObj.special : false,
  });
    const [editClicked, setEditClicked] = useState(false);
    // 2026-07-16: once an address is fully specified (predefined pick, search,
    // or Add Address modal save), the address area folds into a compact summary
    // card (like the legacy create screen); the pencil reopens the form, the X
    // clears the address. Never auto-collapses on mount, so edit screens open
    // exactly as before.
    const [addressCollapsed, setAddressCollapsed] = useState(false);
    const hasCompleteAddress = (loc) =>
      Boolean(loc?.customer_address_line_1 && loc?.customer_city && loc?.customer_zipcode);
    // Stricter bar used ONLY by the blur-to-collapse path (below): the user
    // asked that focus-out collapse require the full address — line1, city,
    // state, country and zip. Kept separate from hasCompleteAddress so the
    // existing predefined-select / modal-save collapse behaviour is unchanged.
    const hasAllRequiredForCollapse = (loc) =>
      Boolean(
        loc?.customer_address_line_1 &&
        loc?.customer_city &&
        loc?.customer_state &&
        loc?.customer_country &&
        loc?.customer_zipcode
      );
    // Keyboard cascade: when the address folds into the summary card, carry the
    // user to the leg's next editable control (first enabled select/input after
    // the card — normally the Level Of Service select). Deferred a tick so the
    // collapsed layout has rendered.
    const legBodyRef = useRef(null);
    // Wraps ONLY the address block (AddressV2). The focus-out-to-collapse logic
    // scopes to this block, so leaving the address fields — even into the leg's
    // Service Details below — folds the address into its summary card.
    const addressBlockRef = useRef(null);
    // Set briefly right after a web address pick. A web selection fills the
    // address but not the name/contact fields, and the picked dropdown row then
    // unmounts (focus drops to <body>) — which would otherwise trip the focus-out
    // collapse immediately. This keeps the block open so the user can add the
    // location name / contact details before it folds.
    const suppressBlurCollapseRef = useRef(false);
    // Tracks whether the user has explicitly toggled the address type, so the
    // async account-default effect below never clobbers a manual choice.
    const addressTypeTouchedRef = useRef(false);
    // The last address_type WE auto-applied from an account default (starts at the
    // init effect's COMMERCIAL fallback). Lets the account-change effect overwrite
    // its own prior value without clobbering an address/template-supplied one.
    const lastAppliedLocTypeRef = useRef("COMMERCIAL");
    // 400ms: the collapse triggers zipcode/date verifications whose setState
    // re-renders can drop an earlier focus; browser-verified timing.
    const focusNextEditable = () =>
      deferFocus(
        () =>
          legBodyRef.current?.querySelector(
            '.ant-select:not(.ant-select-disabled), input:not([type="hidden"]):not([disabled]):not([readonly])'
          ),
        400
      );
    // Portal-rendered overlays owned by address-block controls (their focus lands
    // OUTSIDE the block in the DOM — the phone country list and the inline address
    // search dropdown). While one is open the user is still working within the
    // address block, so a blur into it must NOT collapse the card.
    const ADDRESS_OVERLAY_SELECTOR =
      ".lav2-phone__dropdown, .country-list, .oc-search__dd, .pac-container, .ant-select-dropdown";
    // Collapse the address into its summary card when focus leaves the ADDRESS
    // block and the full address (line1/city/state/country/zip) is present.
    // Complements the predefined-select and modal-save collapse paths so a
    // manually-typed address folds the same way. Guards below prevent collapsing
    // while the user is still inside the block or picking from one of its dropdowns.
    const handleAddressBlockBlur = (e) => {
      if (checkIsCrossDockLocation()) return;              // no collapsed card for cross-dock
      if (addressCollapsed) return;                         // already folded
      if (suppressBlurCollapseRef.current) return;          // just picked a web address — keep block open
      if (!hasAllRequiredForCollapse(location)) return;     // not fully entered yet
      const related = e.relatedTarget;
      if (related && addressBlockRef.current?.contains(related)) return; // focus stayed in the block
      if (related && related.closest?.(ADDRESS_OVERLAY_SELECTOR)) return; // focus moved into a block overlay
      // Defer a tick so focus settles (handles relatedTarget === null clicks and
      // portal timing), then confirm focus truly left the block and no overlay holds it.
      setTimeout(() => {
        if (!addressBlockRef.current) return;
        if (suppressBlurCollapseRef.current) return;
        const active = document.activeElement;
        if (addressBlockRef.current.contains(active)) return;
        if (active && active.closest?.(ADDRESS_OVERLAY_SELECTOR)) return;
        if (!addressCollapsed && hasAllRequiredForCollapse(location)) {
          setAddressCollapsed(true);
        }
      }, 0);
    };

    // Collapse on an outside CLICK too, not only focus-out. The blur handler
    // fires only when focus actually leaves the block — but re-opening a
    // collapsed card via its Edit button focuses nothing, so a subsequent click
    // outside produced no blur and the card never re-folded. This listener closes
    // that gap. Uses "click" (not mousedown) so the outside element receives the
    // interaction before the collapse shifts the layout.
    useEffect(() => {
      if (addressCollapsed || checkIsCrossDockLocation()) return undefined;
      const onDocClick = (e) => {
        if (suppressBlurCollapseRef.current) return;
        const t = e.target;
        if (!addressBlockRef.current) return;
        if (addressBlockRef.current.contains(t)) return;            // click inside the block
        if (t.closest && t.closest(ADDRESS_OVERLAY_SELECTOR)) return; // click in a block overlay
        if (!hasAllRequiredForCollapse(location)) return;
        setAddressCollapsed(true);
      };
      document.addEventListener("click", onDocClick);
      return () => document.removeEventListener("click", onDocClick);
    }, [addressCollapsed, location]);
    const [customTimeObj, setCustomTimeObj] = useState({});
    const [orderAccessorials, setOrderAccessorials] = useState([]);
    const [currentSelectedAccessorial, setCurrentSelectedAccessorial] = useState([])
  const [stateChanged, setStateChanged] = useState({});
    const [availableDatesInfo, setAvailableDatesInfo] = useState({
        feasible_dow: locObj.feasible_dow || [],
        feasible_dates: locObj.feasible_dates || [],
    });
    const [authorizeDetails, setAuthorizeDetails] = useState({});
    const [showAddAddressModal, setShowAddAddressModal] = useState(false);
    const [hoveredField, setHoveredField] = useState(null);
    const [tempLocation, setTempLocation] = useState({
      ...(actionType === 'create' ? {customer_country: 'USA'} : {})
    });
    const isMilitaryTime = orgSettings.is_military_time == 'true';
    const showAppointmentCheckbox = orgSettings?.show_appointment_checkbox_in_create_edit_order_screen == 'true';
    const timeFormat = isMilitaryTime ? "HH:mm" : "hh:mm A";
    const emptyText = "Not Available";
    const [isLosCodeChanged, setIsLosCodeChanged] = useState(false);
    const [whZipCodeData, setWhZipCodeData] = useState([]);
    const [showWarningWhModal,setWarningWhModal] = useState(false);
    const [inProgress, setInProgress] = useState(false);
    const [selectedWarehouseId, setSelectedWarehouseId] = useState(null);
    const [renderModalActions, setRenderModalActions] = useState(false);
    const [warningText, setWarningText] = useState("")

    useEffect(() => {
      // Step 1: Determine the accessorials source based on `rebilled_order_id`
      const isRebilledOrder = !isEmpty(orderResponse?.rebilled_order_id)
      const accessorials = isRebilledOrder
        ? Array.isArray(locObj.accessorials) &&
          locObj.accessorials.length > 0
          ? locObj.accessorials
          : currentSelectedAccessorial || []
        : locObj.accessorials || [];

      const authorizeDetails = {};
      const allowedIds = {};

      // Step 2: Build allowedIds map
      accountComponentAccessorial.forEach((accessorial) => {
        const components = accessorial.components
          ? accessorial.components.map((record) => record.component_code)
          : [];
        allowedIds[accessorial.id] = [...components];
      });

      // Step 3: Build accessorial info
      const orderAccessorialsInfo = setAccessorialResponse(
        accessorials,
        true,
        allowedIds
      );

      // Step 4: Extract authorized details
      orderAccessorialsInfo.forEach((rec) => {
        if (!isEmpty(rec.authorized_by)) {
          authorizeDetails[rec.accessorial_code] = {
            authorized_by: rec.authorized_by,
            authorization_code: rec.authorization_code,
            comments: rec.comments,
            is_modified: false,
          };
        }
      });

      // If rebilled_order_id is true, merge common/master accessorials
      if (isRebilledOrder) {
        const currentAccIds = accountComponentAccessorial.map((rec) => rec.id);

        const existingCommonAccessorials = orderAccessorials.filter((item) =>
          currentAccIds.includes(item.accessorial_id)
        );

        const mergedAccessorials = [
          ...existingCommonAccessorials,
          ...orderAccessorialsInfo.filter(
            (item) => !currentAccIds.includes(item.accessorial_id)
          ),
        ];

        setAuthorizeDetails(authorizeDetails);
        setOrderAccessorials(mergedAccessorials);
      } else {
        // Normal case
        setAuthorizeDetails(authorizeDetails);
        setOrderAccessorials(orderAccessorialsInfo);
      }
    }, [
      locObj.accessorials,
      accountComponentAccessorial,
      props?.displayComponents,
    ]);


    // const accessorialRef = useRef(null);

    const [isNew, setIsNew] = useState(true);
    const MultiStop = orderTypeConfig.code !== "MS";
    const isLinehaulCode = ["LH","NLH", "PLH", "LHD"].includes(orderTypeConfig.code);
    const isDstOrOrn = ["DST", "ORN"].includes(locObj.label_code);

    // Previous auto-fill warehouse id for this leg. Lets the WH auto-fill effects
    // tell a real warehouse CHANGE (user picked a different WH -> take the new
    // WH's details) apart from an unrelated re-render/mount (preserve the leg's
    // own loaded values so an edited order isn't wiped).
    const prevWhIdRef = useRef(undefined);

    const formRef = useRef(null);

    useEffect(() => {
        if (multistopLocationRef) {
            multistopLocationRef.current = () => ({
                ...location
            })
        }
    }, [location, multistopLocationRef])

    useEffect(() => {
        if (getDataRef) {
         // const accessorialData = accessorialRef?.current() || [];
          getDataRef.current = () => ({
            ...location,
            accessorials: orderAccessorials.map(acc => ({ ...acc, accessorial_type: acc.accessorial_type || '' })),
          });
          if(updateLocData){
            updateLocData()
          }
          
        }
    }, [location, getDataRef, orderAccessorials]);

    useEffect(() => {
        const isCrossDock = ['CDK', 'WO'].includes(locObj.label_code) || ['CDK', 'WO'].includes(orderTypeConfig.code)
        const isLinehaulPickup = ['LH', 'NLH', 'LHD'].includes(orderTypeConfig.code) && locObj.type_of_loc === "PICKUP";
        if ((isCrossDock || isLinehaulPickup) && selectedWarehouse) {
          const whChanged = !isCrossDock && prevWhIdRef.current !== undefined && prevWhIdRef.current !== selectedWarehouse?.id;
          prevWhIdRef.current = selectedWarehouse?.id;
          // Linehaul: do not push warehouse/terminal address onto pickup on load or
          // re-render. Pickup keeps the order/API address. Apply warehouse details
          // only after the user confirms a warehouse change.
          if (isLinehaulPickup && !whChanged) {
            return;
          }
          if(!locObj?.id || whChanged){
             onAddressSelect({
              ...selectedWarehouse,
              company_name: isCrossDock ? "" : (selectedWarehouse.company_name || ""),
              email: isCrossDock ? "" : (selectedWarehouse.email || ""),
              phone: isCrossDock ? "" : (selectedWarehouse.phone || ""),
              l_address: selectedWarehouse.l_address,
              l_type: 'WH',
              type: 'predefined'
             });
          } else {

              onAddressSelect({
               ...selectedWarehouse,
               company_name: location?.company_name || selectedWarehouse.company_name || "",
               email: location?.email || selectedWarehouse.email || "" ,
               phone: location?.phone || selectedWarehouse.phone || "" ,
               l_address: location?.l_address || selectedWarehouse.l_address || {} ,
               l_type: 'WH',
               type: 'predefined'
              });

          }
        }
    }, [orderTypeConfig?.code, selectedWarehouse]);

    useEffect(() => {
        if ((orderTypeConfig.code === 'LH'|| orderTypeConfig.code === 'NLH' || orderTypeConfig.code === 'LHD') && locObj.label_code == 'ORN' && selectedWarehouse) {
            const whChanged = prevWhIdRef.current !== undefined && prevWhIdRef.current !== selectedWarehouse?.id;
            prevWhIdRef.current = selectedWarehouse?.id;
            // Same as pickup: never overwrite a loaded origin address with the
            // selected warehouse/terminal unless the user changed warehouse.
            if (!whChanged) {
              return;
            }
            onAddressSelect({
              ...selectedWarehouse,
              company_name: selectedWarehouse.company_name || "",
              email: selectedWarehouse.email || "",
              phone: selectedWarehouse.phone || "",
              l_address: selectedWarehouse.l_address || {},
              l_type: 'WH',
              type: 'predefined'
            });
        }
    }, [orderTypeConfig, selectedWarehouse]);

  useEffect(() => {
    // if(!locObj.id){ muted the line to allow los change on edit mode as well
      const key = locObj?.type_of_loc ? (locObj.type_of_loc === 'PICKUP' ? 'default_pickup_los' : 'default_delivery_los') : '';
      const incomingLos = locObj && locObj.los_code ? locObj.los_code : "";
      const currentAcc = orderResponse && orderResponse.account && orderResponse.account.id ? orderResponse.account.id : null;
      let defaultLos = key ? (_.get(_.find(levelOfServices, { [key]: true}), "code", "") || "") : "";
      // The currently selected account (from the AccountBlockV2 picker). Previously
      // this read accInputRef, but that ref was only written by the old Select_v2
      // dropdown; after the migration to AccountBlockV2 it stays null, so the
      // account-change reset (Case 2) never fired and legs kept the old tariff.
      // currentAccount.id is the live selection; orderResponse.account.id (currentAcc)
      // is the account the order was saved with. Undefined while the account is still
      // loading (currentAccount === {}), which the race guard below treats as "no change yet".
      const accVal = currentAccount && currentAccount.id ? currentAccount.id : null;

      // For new APAD orders, always set LOS to NONE
      if (orderTypeConfig?.extraCode === "APAD" && screenMode !== "full_edit") {
        const noneLos = _.find(levelOfServices, { code: "NONE" });
        const noneCode = noneLos ? noneLos.code : "NONE";
        if (incomingLos !== noneCode) {
          handleOnChangeDirect("los_code", noneCode);
          setFieldsValue({ los_code: noneCode });
          setFieldsValue({ [`${locObj.loc_order_sequence}_${locObj.label_code}_los_code`]: noneCode });
        }
        return;
      }

      // Account CHANGED on edit: the leg still carries the PREVIOUS account's tariff.
      // Remap it to the NEW account's tariff — the service-level leg default (Mode A)
      // wins, else the account's default pickup/delivery LOS (Mode B), else clear so a
      // later resolve fills it. This is the SINGLE writer for the account-change case
      // (Effect B below no longer clears los_code on change), so the two effects can't
      // fight and blank the value. accVal (currentAccount.id) present AND != the saved
      // account (currentAcc) is a real user account change; an empty accVal is just the
      // account still hydrating (handled as "unchanged" below). This runs regardless of
      // whether the leg already has a los_code — on account change the saved code is the
      // old account's and must be replaced.
      if (accVal && currentAcc && accVal !== currentAcc) {
        const remapped =
          serviceLevelLosCode && levelOfServices.some((los) => los.code === serviceLevelLosCode)
            ? serviceLevelLosCode
            : (defaultLos || "");
        handleOnChangeDirect("los_code", remapped);
        setFieldsValue({ los_code: remapped });
        setFieldsValue({ [`${locObj.loc_order_sequence}_${locObj.label_code}_los_code`]: remapped });
        return;
      }

      // Phase 4.1 F1 Mode A: an explicit per-leg service-level tariff was threaded
      // in and it's a selectable option for this account/order-type -> it wins over
      // every default/incoming case below. Absent (Mode B), this branch is skipped
      // entirely and the original Case 1/incoming logic runs unchanged.
      // Guard on isEmpty(incomingLos): on EDIT (account unchanged) the leg carries a
      // SAVED los_code (possibly changed by the user away from the SL default) — never
      // clobber it with the SL default. On create / SL-change the leg is seeded upstream
      // so incomingLos already equals the intended default, so this stays a no-op there.
      if (serviceLevelLosCode && isEmpty(incomingLos) && levelOfServices.some(los => los.code === serviceLevelLosCode)) {
        handleOnChangeDirect("los_code", serviceLevelLosCode);
        setFieldsValue({ los_code: serviceLevelLosCode });
        setFieldsValue({ [`${locObj.loc_order_sequence}_${locObj.label_code}_los_code`]: serviceLevelLosCode });
        return;
      }

      // Case 1: no LOS in locObj -> set default if available
      if (key && isEmpty(incomingLos)) {
        if (defaultLos) {
          handleOnChangeDirect("los_code", defaultLos);
          setFieldsValue({ los_code: defaultLos });
          setFieldsValue({ [`${locObj.loc_order_sequence}_${locObj.label_code}_los_code`]: defaultLos });
        }
        return;
      }

      // Account unchanged (accVal === currentAcc) or still hydrating (!accVal):
      // honor the saved incoming LOS — never clobber it on edit load.
      if (!isEmpty(incomingLos)) {
        setFieldsValue({ los_code: incomingLos });
        setFieldsValue({ [`${locObj.loc_order_sequence}_${locObj.label_code}_los_code`]: incomingLos });
      }
    // }
  }, [levelOfServices, orderTypeConfig?.code, serviceLevelLosCode]);

  // Account-first default (product rule): when a service-level default code exists
  // in BOTH the account sheet and the org Standard sheet, the ACCOUNT tariff is the
  // default. So the leg is intentionally left WITHOUT a los_id / rate_sheet_id on the
  // auto-select path: a blank rate_sheet_id makes the LOS dropdown resolve to the
  // account option (see the `value` derivation below) AND makes the backend resolve
  // the LOS account-first (Standard is only a fallback when the account lacks the
  // code — location_create_service#add_los_to_location). Picking the Standard option
  // manually sets rate_sheet_id on the leg (the Select onChange), so that pick bills
  // against the Standard sheet. (A prior "pin" effect here force-selected the Standard
  // tariff over the account's same-code one — removed to satisfy account-first.)

  const locType = selectedButton ? selectedButton : locObj.type_of_loc;
  useEffect(() => {
   
    if (screenMode === "full_edit") {
      if (orderTypeConfig?.code && orderResponse?.order_label !== orderTypeConfig?.code) {
        setLocation((prevLocation) => ({
          ...prevLocation,
          l_type: getLocationType(orderTypeConfig, locType, prevLocation),
        }));
      }
    } else {
        setLocation((prevLocation) => ({
        ...prevLocation,
        l_type: getLocationType(orderTypeConfig, locType, prevLocation),
        // Default to the selected account's configured default location type
        // (Org/Account Settings), falling back to COMMERCIAL when unset.
        address_type: locObj?.address_type || accountConfig?.default_location_type || "COMMERCIAL",
        operational_use: locObj?.operational_use || "FINAL_MILE",
        secondary_loc_type: normalizeSecondaryLocType(locObj?.secondary_loc_type),
      }));
      // Record the account default we just seeded so the account-change effect
      // below recognises it as "ours" (and can re-default on the next switch).
      lastAppliedLocTypeRef.current = accountConfig?.default_location_type || "COMMERCIAL";
    }
  }, [orderTypeConfig?.code]);

  // The account config loads asynchronously, and the selected account can be changed
  // after the fact. Apply the account's default location type (falling back to
  // COMMERCIAL when unset) whenever it resolves/changes, so switching from a
  // Residential-default account to a Commercial/unset one resets the checkbox.
  // We only overwrite a value WE auto-applied (tracked in lastAppliedLocTypeRef) so a
  // manual toggle or a value carried in by an address/template is never clobbered.
  useEffect(() => {
    if (actionType !== "create") return;
    if (addressTypeTouchedRef.current) return;
    const acctDefault = accountConfig?.default_location_type || "COMMERCIAL";
    setLocation((prevLocation) => {
      const current = prevLocation.address_type;
      // Preserve a value that isn't the account default we last applied (a manual
      // toggle or an address/template-supplied type). Only record the ref when we
      // actually apply, so a bailed update doesn't mark a foreign value as "ours".
      if (current && current !== lastAppliedLocTypeRef.current) return prevLocation;
      lastAppliedLocTypeRef.current = acctDefault;
      return { ...prevLocation, address_type: acctDefault };
    });
  }, [accountConfig?.default_location_type]);


  useEffect(() => {
    const locationZipcode = location.customer_zipcode;
    const zipcodechanged = stateChanged?.prev_zipcode
    const DIGITVALIDATION = /^[0-9]{5}$/;
    const onlyForSSF = currentOrg?.code === "SSF"
    if (orderTypeConfig?.type_of_order === "T" && ["T", "B", "E", "H"].includes(orderTypeConfig?.code) && onlyForSSF &&
      (actionType === "create" || actionType === "update")) {
      setStateChanged(prev => ({ ...prev, prev_zipcode: false }))
      if (zipcodechanged && DIGITVALIDATION.test(locationZipcode)) {
        zipcodePLHDcheck();
      }
    }

  }, [location]);

    useEffect(() => {
        if (isEmpty(location.is_signature_required) && actionType === "create") {
            const signReq = config['pod_signature'] === 'true' || isEmpty(config['pod_signature'])
            // setFieldsValue({is_signature_required: signReq})
            handleOnChangeDirect("is_signature_required", signReq)
        }
        if (isEmpty(location.is_form_required) && actionType === "create") {
          let formReq = false

          if(['R'].includes(location.label_code)){
            formReq = config['is_shipper_pickup_form_mandatory'] === 'true'
          }
          if(['D'].includes(location.label_code)){
            formReq = config['is_shipper_delivery_form_mandatory'] === 'true'
          }
          handleOnChangeDirect("is_form_required", formReq)
          // setFieldsValue({is_signature_required: signReq})
      }
    }, [config]);

    useEffect(() => {
       if(actionType === 'create'){
        // Phase 4.1 F1 Mode A: this create-mode effect is declared after the
        // default-LOS effect, so on mount it runs last and is decisive. In Mode A
        // (serviceLevelLosCode present) keep/set the SL tariff here so it is not
        // clobbered; in Mode B (undefined) clear to "" exactly as before.
        const createLos = serviceLevelLosCode ? serviceLevelLosCode : ""
        handleOnChangeDirect("los_code", createLos)
        setFieldsValue({ los_code: createLos })
        setFieldsValue({
            [`${locObj.loc_order_sequence}_${locObj.label_code}_los_code`]: createLos
        })
       } else {
        // EDIT. On a real account change the default-LOS effect above is the SINGLE
        // writer that remaps each leg to the NEW account's tariff (SL leg default in
        // Mode A, else account default). This effect must NOT clear los_code here — it
        // previously did, and because it runs after that effect and re-fires on every
        // serviceLevelLosCode recompute, it kept blanking the freshly-remapped tariff
        // (the reported "default tariffs don't populate" bug). When the account is
        // unchanged, restore the saved leg tariff.
        if(!(orderResponse?.account?.id && currentAccount.id !== orderResponse.account.id)){
             handleOnChangeDirect("los_code", locObj.los_code)
            setFieldsValue({
                [`${locObj.loc_order_sequence}_${locObj.label_code}_los_code`]:  locObj.los_code
            })
        }
       }
    }, [currentAccount.id, serviceLevelLosCode]);

    useEffect(() => {
        const isCreate = actionType === 'create';
        const isUpdate = actionType === 'update' && isLosCodeChanged;
        const isMS = orderTypeConfig.code === 'MS';
        const losCode = isMS && orgSettings?.individual_stop_los_order_level !== "true" ? msLos : location.los_code;

        if ((isCreate || isUpdate) && !isEmpty(losCode)) {
            const duration = getServiceDuration(losCode) || 20;
            handleOnChangeDirect("service_duration", duration);
        }
    }, [orderTypeConfig.code, actionType, location.los_code, msLos, isLosCodeChanged]);

    useEffect(() => {
        handleUpdateWhStorage()
        if(orderTypeConfig.code === "MS" && typeof handleExpedite === "function"){
            handleExpedite(location.appointment)
        }
    }, [location.appointment]);

    useEffect(() => {
        setCurrentSelectedAccessorial(orderAccessorials);
    }, [orderAccessorials]);

    useEffect(() => {
        form.validateFields(['address', 'los_code']);
    }, [location]);

    useEffect(() => {
      const isCrossDockDel = (orderTypeConfig.code === "CDK" || orderTypeConfig.code === "WO") && locObj.label_code === "DRPF";
      if(samaAsOther && isCrossDockDel){
       copyOtherLocation(0, 1)
      }
    }, [location.company_name, location.customer_email, location.customer_phone_one]);
    useEffect(() => {
      const isCrossDockPickup = (orderTypeConfig.code === "CDK" || orderTypeConfig.code === "WO") && locObj.label_code === "R";
      if(keys && isCrossDockPickup && getDataRef){
        const loc = getDataRef.current();
        setLocation((prevLocation) => ({
          ...prevLocation,
          company_name: loc.company_name || "",
          customer_email: loc.customer_email || "",
          customer_phone_one: loc.customer_phone_one || "",
          customer_phone_two: "",
        }));
      }
    }, [keys]);


    const getServiceDuration = (los_code) => {
        const reqLOSObject = getValueFromArrayOfObjects(
            levelOfServices,
            "code",
            los_code
        );
        
        if (reqLOSObject?.duration) {
            return parseInt(reqLOSObject.duration);
        } else if (config && !isEmpty(config.service_duration)) {
            return parseInt(config.service_duration);
        } else if (
            orgSettings &&
            !isEmpty(orgSettings.service_duration)
        ) {
            return parseInt(orgSettings.service_duration);
        }
        return 20;
    };

    const { gridSize } = props;

    const MultiStopGridSizes = gridSize
    ? gridSize
    : {
        xs: 24,
        sm: 24,
        md: 24,
        lg: orderTypeConfig.code === "MS" &&  ["create", "update"].includes(actionType) ? 6 : 12,
        xl: orderTypeConfig.code === "MS" &&  ["create", "update"].includes(actionType) ? 6 : 12,
    };

    const verifyZipcode = (zipData, locationType) => {
      const orgId = currentOrg?.id || '';
      const zipcode = !isEmpty(zipData) ? zipData : null;
      const isValidZip = zipcode && zipcode.length >= 5;
      const accountId = currentAccount?.id;

      if (!isValidZip || !accountId) return;

      verifyBillingZone(orgId, accountId, zipcode).then((result) => {
        if (!result.success) return;

        const losCode = result?.data?.los?.los_code;
        const warehouseCode = result?.data?.wh_code || null;
        const warnings = result?.data?.warnings || [];

        // Update LOS code if available
        if (losCode) {
          handleOnChangeDirect("los_code", losCode);
          form.setFieldsValue({ [`${locObj.loc_order_sequence}_${locObj.label_code}_los_code`]: losCode });
        }
        if (locationType === "PICKUP") {
          setOriginCode(warehouseCode);
          setCurrentLocType("PICKUP")
          // Optionally return here if you want to prevent further execution
        } else if (locationType === "DELIVERY") {
          setDestinationCode(warehouseCode);
          setCurrentLocType("DELIVERY")
        }
        // Handle warehouse code
        if (_.isEmpty(warehouseCode) && _.get(orderTypeConfig, "code") !== "PLHD") {
          alertMessage([`No ${I18n.t('general.warehouse')} found for the given zipcode.`], "warning", 5);
          setCurrentWhCode(null)
        } 
        // Show any warnings
        if (warnings.length > 0) {
          alertMessage(warnings, "warning", 5);
        }
      });
    }

    const verifyWhZipCodes = async(zipData, locationType) => {
        
      const allowWhZipcodeValidation = orgContext?.orgSettings?.add_zip_to_warehouse == "true";

     const parsedData = JSON.parse(sessionStorage.getItem("zipCodeFocus") || "null");
      if ((parsedData?.zipcode || "") === zipData) {
            return;
          }

       if (!allowWhZipcodeValidation) return;

      // rest of your logic runs only when true

      // continue execution here for SSF only

        const response = await generalizedverifyWarehouseZipCodes({
          orgId: currentOrg?.id,
          zipcode: zipData,
          warehouseId: locObj?.type_of_loc === "DELIVERY" ? parsedData?.warehouseId  || _.get(selectedWarehouse, "id") :  _.get(selectedWarehouse, "id"),
          typeOfLoc: locObj.type_of_loc,
          orderTypeCode: _.get(orderTypeConfig, "code")
        });

        if (response) {
          setWhZipCodeData(response.warehouses);
          setRenderModalActions(response.renderActions);
          setWarningText(response.warningText);
          setWarningWhModal(true);
        }
    }

        const ProceedSelection = async () => {
          


          // if(!renderModalActions){
            if(locObj.type_of_loc === "PICKUP"){
            updateOrderDetails("warehouse_id",selectedWarehouseId);
            }
            setWarningWhModal(false);    
            setWhZipCodeData([]);   
            setRenderModalActions(false); 
            setWarningText("");    
          // }
          const zipCodeData = {
            isFocused: false,
            zipcode: tempLocation?.customer_zipcode || location?.customer_zipcode || "",
            warehouseId: selectedWarehouseId
          };
          // Save in sessionStorage
          sessionStorage.setItem("zipCodeFocus", JSON.stringify(zipCodeData));
          if(!renderModalActions){
            return;
          }
          setInProgress(true);
          const payload = {
            org_id: currentOrg?.id || "",
            warehouse_id: selectedWarehouseId,
            zipcode: tempLocation?.customer_zipcode || location?.customer_zipcode || "",
          }
          try{
            const response = await proccedWithWh(payload);
            if(response.success){
              alertMessage(response.data.message, "success", 5);
              if(locObj.type_of_loc === "PICKUP"){
              updateOrderDetails("warehouse_id",selectedWarehouseId);
              }
              setWarningWhModal(false);           
            }else{
              renderAlertMessage(response.data.errors)
            }
          } catch(error){
            console.error("Failed to Process", error);
            alertMessage("Failed to process warehouse selection.", "error", 5);
          }finally{
            setInProgress(false);
            setSelectedWarehouseId(null)
          }
    }

    const getAvailableDates = (zipcode) => {
        if (
            checkServiceExistance("DDBOZ") &&
            !isEmpty(currentAccount) &&
            !isEmpty(zipcode)
        ) {
            fetchAvailableDates(currentAccount.code, zipcode).then(
                (result) => {
                    if (result.success) {
                        const availableDates = result.availableDates || {};

                        setAvailableDatesInfo({
                            feasible_dow: availableDates.feasible_dow || [],
                            feasible_dates: availableDates.feasible_dates || [],
                        })

                    } else {
                        renderAlertMessage(result.errors)
                        this.setState({ inProgress: false });
                    }
                }
            );
        }
    };

    const getLabelForAppointments = () => {
        if (_.includes(orderTypeConfig.code, "CDK") || _.includes(orderTypeConfig.code, "WO")) {
            const labelCode = generateOrderCombinedCode();
            if (labelCode == "PCDK-CDK" || labelCode == "CDK-R" || labelCode == "WO-R") {
                return "Pick by";
            } else if (labelCode == "CDKD-CDK" || labelCode == "CDK-DRPF" || labelCode == "WO-DRPF") {
                return "Drop by";
            }
        }
        if (["MWE", "FET"].includes(currentOrg?.code)) {
            if (location?.appointment?.has_appointment) {
                return "Appointment Date";
            } else if (location?.appointment?.has_expedite) {
                return "Appointment Date";
            } else {
                return "Service Date";
            }
        }
      return I18n.t("general.appointment");
    };
    const getLabelForCdkAppointments = () => {
      if (_.includes(orderTypeConfig.code, "CDK") || _.includes(orderTypeConfig.code, "WO")) {
          const labelCode = generateOrderCombinedCode();
          if (labelCode == "PCDK-CDK" || labelCode == "CDK-R" || labelCode == "WO-R") {
              return "Picked Up";
          } else if (labelCode == "CDKD-CDK" || labelCode == "CDK-DRPF" || labelCode == "WO-DRPF") {
              return "Received";
          }
      }
      return I18n.t("general.appointment");
  };
    const handleOnChangeDirect = (key, value) => {
      if (key === "customer_zipcode") {
        value = String(value || "").replace(/\D/g, "");
      }
      if (key === "address_type") {
        addressTypeTouchedRef.current = true;
      }
      if(key === "actual_start_datetime"){
        const formattedValue = moment(value).format("YYYY-MM-DD HH:mm");
        setLocation((prevLocation) => ({
          ...prevLocation,
          [key]: formattedValue,
          cdk_actual_times: formattedValue
        }))
      }
      
        if ( ["customer_phone_one","customer_phone_two"].includes(key)) {
            const phoneWithoutCountryCode = String(value || "").replace(/[^0-9]/g, '');
            // const countryCodeLength = value.startsWith('+') ? 1 : 0;
            const isValid = !phoneWithoutCountryCode || [10, 11, 12].includes(phoneWithoutCountryCode.length)
            if (!isValid) {                
                setLocation((prevLocation) => ({
                    ...prevLocation,
                    [key]: value,
                    phoneError: true,
                }));
            } else {
                setLocation((prevLocation) => ({
                    ...prevLocation,
                    [key]: value,
                    phoneError: '',
                }));
            }
        } else {            
            setLocation((prevLocation) => ({
                ...prevLocation,
                [key]: value,
            }));
        }
    };

    const handleAppointmentTimeChange = (dateVal, customTimeObj,custom_time) => {
      
        // if both are empty just return empty
        if(isEmpty(dateVal) && isEmpty(customTimeObj)){
            setLocation((prevLocation) => ({
                ...prevLocation,
                appointment: {
                    ...prevLocation.appointment,
                    start_time: "",
                    end_time: "",
                },
            }));
            return;
        }
        setCustomTimeObj(customTimeObj)

        if (custom_time === "custom_time") {
       
          const {start_time, end_time} = customTimeObj;
          setLocation((prevLocation) => ({
              ...prevLocation,
              appointment: {
                  ...prevLocation.appointment,
                  start_time: start_time,
                  end_time: end_time,
                  slot: dateVal == "08:00-20:00" ? "ANY" : "CUSTOM",
              },
          }));
       
          return
      }
        if (custom_time !== "custom_time") {
            const [startTime, endTime] = dateVal.split("-");

            setLocation((prevLocation) => ({
                ...prevLocation,
                appointment: {
                    ...prevLocation.appointment,
                    start_time: startTime,
                    end_time: endTime,
                    slot: dateVal == "08:00-20:00" ? "ANY" : dateVal,
                },

            }));
        }
    };

    const handleOnChange = (key, subKey, value) => {
      if(key === "appt_date") {
        let endDate = "";
        let startDate = "";
        if (currentPreplan?.delivery_start_date) {
          startDate = moment(currentPreplan.delivery_start_date).format(
            "YYYY-MM-DD"
          );
          endDate =
            currentPreplan.preplan_type === "single_day"
              ? startDate
              : moment(currentPreplan.delivery_end_date).format("YYYY-MM-DD");
        } else if (currentRoute?.r_scheduled_start_datetime && currentRoute?.r_scheduled_end_datetime) {
          startDate = moment(currentRoute.r_scheduled_start_datetime).format(
            "YYYY-MM-DD"
          );
          endDate = moment(currentRoute.r_scheduled_end_datetime).format(
            "YYYY-MM-DD"
          );
        }
        const selectedDate = moment(value).format("YYYY-MM-DD");
        const isOutOfPreplan =
          !isEmpty(value) &&
          startDate &&
          endDate &&
          !isBetweenDates(startDate, endDate, selectedDate);
        setOutofPreplan(isOutOfPreplan);
        setLocation((prevLocation) => ({
          ...prevLocation,
          [subKey]: {
              ...prevLocation[subKey],
              [key]: value,
          },
         }));
      } else {
        setLocation((prevLocation) => ({
          ...prevLocation,
          [subKey]: {
              ...prevLocation[subKey],
              [key]: value,
          },
         }));
      }
        
    };

    const handleOnChangeAddress = (selectedAddress) => {

        if (!selectedAddress || typeof selectedAddress !== "string") {
            console.error("Invalid address provided");
            return;
        }
        
        let addressArray = selectedAddress.split(",");
        const output = {
          zipcode: "",
          country: "",
          state: "",
          city: "",
          address_line2: "",
          address_line1: "",
        };
        const address_line1 = addressArray.splice(0, 1).join(", ");
        addressArray = addressArray.reverse();
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < addressArray.length; i++) {
          output[Object.keys(output)[i]] = addressArray[i];
        }
        output.address_line1 =
          addressArray.length > 5
            ? `${address_line1}, ${addressArray.slice(5).reverse().join(", ")}`
            : address_line1;
        

        setLocation({
            //...selectedAddress,
            ...location,
            customer_address_line_1: output?.address_line1 || '',
            customer_address_line_2: output?.address_line2 || '',
            customer_city: output?.city || "",
            customer_state: output?.state || "",
            customer_country: output?.country || "",
            customer_zipcode: output?.zipcode || "",
        });

    }

    function getLocationType(orderTypeConfig, locType, selectedAddress) {
      const { code } = orderTypeConfig;
      const isORandDelivery = code === "OR" && locType === "DELIVERY";
      const isODandPickup = code === "OD" && locType === "PICKUP";
    
      if (["OR", "OD"].includes(code) && (isORandDelivery || isODandPickup)) {
        if (selectedAddress?.l_type === "WH") return "PWL";
        if (selectedAddress?.l_type === "PWL") return "CS";
        return "CS";
      }
      return (code === "LH" || code === "NLH") ? "WH" : "CS";
    }

    const onAddressSelect = (selectedAddress, opts = {}) => {
        if(!selectedAddress){
            return ;
        }
        const openModal = opts.openModal !== false;
        if (selectedAddress.type == "web") {
            setEditClicked(true);
            if (openModal) {
                closeModelOnSelection ? setShowAddAddressModal(false) : setShowAddAddressModal(true);
            }
        }
        if (["LH", "NLH", "PLH", "PLHD"].includes(orderTypeConfig.code) && locObj.type_of_loc === "DELIVERY") {
            setTargetWarehouse(selectedAddress.id)
        }

        const addressDetails = {
            ...location,
            company_name: selectedAddress.type === 'predefined' ? selectedAddress.company_name : selectedAddress.company_name,
            customer_email: selectedAddress.type === 'predefined' ? selectedAddress.email : selectedAddress.email,
            customer_address_line_1: selectedAddress?.l_address?.address_line1 || '',
            customer_address_line_2: selectedAddress?.l_address?.address_line2 || '',
            customer_city: selectedAddress?.l_address?.city || "",
            customer_state: selectedAddress?.l_address?.state || "",
            customer_country: selectedAddress?.l_address?.country || "",
            customer_zipcode: selectedAddress?.l_address?.zipcode || "",
            address_type: selectedAddress?.l_address?.address_type || selectedAddress?.address_type || accountConfig?.default_location_type || "COMMERCIAL",
            operational_use: selectedAddress?.operational_use || "FINAL_MILE",
            secondary_loc_type: normalizeSecondaryLocType(selectedAddress?.secondary_loc_type),
            customer_phone_one: selectedAddress.type === 'predefined' ? selectedAddress.phone : selectedAddress.phone,
            customer_phone_two: selectedAddress.type === 'predefined' ? selectedAddress.phone_2 : selectedAddress.phone_2,
            customer_first_name: selectedAddress.type === 'predefined' ? selectedAddress.first_name : "",
            customer_last_name: selectedAddress.type === 'predefined' ? selectedAddress.last_name : "",
            l_type: (orderTypeConfig.code === 'LH'||orderTypeConfig.code === 'NLH'|| orderTypeConfig.code === 'LHD') && locObj.type_of_loc === "PICKUP" ? 'WH' : getLocationType(orderTypeConfig, locType, selectedAddress),
            label_code: locObj.label_code,
            type_of_loc: locType,
            // Operational hours + predefined metadata shown in the collapsed summary
            // card. Only predefined picks carry these (start_time/end_time are HH:mm
            // operating hours on the Location record); cleared for web picks.
            start_time: selectedAddress.type === 'predefined' ? (selectedAddress.start_time || "") : "",
            end_time: selectedAddress.type === 'predefined' ? (selectedAddress.end_time || "") : "",
            location_code: selectedAddress.type === 'predefined' ? (selectedAddress.location_code || "") : "",
            location_name: selectedAddress.type === 'predefined' ? (selectedAddress.name || "") : "",
            notes: selectedAddress.type === 'predefined' ? (selectedAddress.notes || "") : "",
        };

        setLocation(addressDetails);
        setStateChanged({ prev_zipcode: true });
        // Fully-specified non-web selection -> fold into the summary card.
        if (selectedAddress.type !== "web" && hasCompleteAddress(addressDetails)) {
          setAddressCollapsed(true);
          focusNextEditable();
        } else if (selectedAddress.type === "web") {
          // A web pick fills the address but NOT the name/contact fields. Keep the
          // block open (don't collapse) so the user can add name/contact. The
          // suppress flag covers the brief window where the picked dropdown row
          // unmounts and focus drops to <body> before any follow-up focus lands,
          // which would otherwise trip the focus-out collapse. Applies to picks
          // from every search field (Search Location / Name / Street).
          suppressBlurCollapseRef.current = true;
          // Only the top Search Location pick nudges focus to the Name field. For
          // Name/Street picks, leave focus where the user is (no jump back up).
          if (opts.focusName) {
            deferFocus(
              () => addressBlockRef.current?.querySelector('input[name="lav2_company_name"]'),
              50
            );
          }
          setTimeout(() => { suppressBlurCollapseRef.current = false; }, 600);
        }

        if (selectedAddress?.l_address?.zipcode) {
            verifyZipcode(selectedAddress.l_address.zipcode, location?.type_of_loc)
              verifyWhZipCodes(selectedAddress.l_address.zipcode, location?.type_of_loc)
            getAvailableDates(selectedAddress.l_address.zipcode)
        }
    };

  const onSelectForCrossDock = (selectedAddress) => {
    const addressDetails = {
      ...location,
      company_name: selectedAddress?.company_name || '',
      customer_email: selectedAddress?.email || '',
      customer_phone_one: selectedAddress?.phone || '',
    };

    setLocation(addressDetails);
  };

    const restDetailsFun = (isRequired) => {
        const hasDeliveryZipcodesConfig =
            (config.validate_delivery_zipcode === "BOTH" ||
                location.address_type ===
                config.validate_delivery_zipcode) &&
            config.delivery_zipcodes === "true";

        // Normalize appointmentTime as an object with start_time and end_time
        const appointmentTime = customTimeObj?.start_time && customTimeObj?.end_time
            ? {
                start_time: customTimeObj.start_time,
                end_time: customTimeObj.end_time
            }
            : location?.appointment?.start_time && location?.appointment?.end_time
                ? {
                    start_time: location.appointment.start_time,
                    end_time: location.appointment.end_time
                }
                : null;

        const slotOptions = (() => {
          const defaultSlot = { label: "08:00 - 20:00", value: "08:00-20:00" };

          if (selectedWarehouse?.slot_details?.length > 0) {
            const slots = selectedWarehouse.slot_details?.map(slot => ({
              label: `${slot.start_time} - ${slot.end_time}`,
              value: `${slot.start_time}-${slot.end_time}`,
            }));

            const hasDefaultSlot = selectedWarehouse?.slot_details.some(
              slot => slot.start_time === "08:00" && slot.end_time === "20:00"
            );

            return hasDefaultSlot ? slots : [...slots, defaultSlot];
          }

          return [defaultSlot];
        })();

        const options = _.uniqBy(_.compact([
            ...slotOptions,
            appointmentTime && {
                label: `${appointmentTime.start_time} - ${appointmentTime.end_time}`,
                value: `${appointmentTime.start_time}-${appointmentTime.end_time}`,
            },
            { label: "Custom Time Window", value: "custom_time" },
        ]), 'value');
        const nonMsNOnCDK = orderTypeConfig?.code !== "MS" && (orderTypeConfig?.code === "CDK" || orderTypeConfig?.code === "WO")
        const hideNonCDK = location?.label_code === "CDK" 
        const hideNonCdkAppointment = nonMsNOnCDK ? true:hideNonCDK ? true : false
        // v2 label styling applies to every leg (including cross-dock) so the
        // cards visually match. The new ServiceDetailsV2 header is a separate
        // concern — keep skipping it for cross-dock so we don't ADD a section
        // header that wasn't there before; only styling changes for cross-dock.
        const useV2SvcLabels = true;
        const showV2SvcHeader = !checkIsCrossDockLocation();
        const svcLabelClass = useV2SvcLabels ? "sdv2-label" : "heading-3-large";
        const svcLabelRowStyle = useV2SvcLabels ? { lineHeight: "20px" } : { lineHeight: "30px" };
        const showMilesField = !["R", "D", "MS", "LH", "NLH", "M"].includes(orderTypeConfig?.code);

        const milesFieldCol = showMilesField && (
            // Miles sits as `afterTimeCol` inside AppointmentWindow's flat
            // div. When it wraps to a new line (typical for cross-dock CDK
            // where time takes most of the row width), the wrap had no
            // vertical spacing. Force a small top gap so the wrapped Miles
            // row breathes like the other field rows.
            <Col span={orderTypeConfig.code === "MS" ? 6 : 12} {...(orderTypeConfig.code === "MS" ? MultiStopGridSizes : gridSizes)} className="table-col-address marginTop8">
                <Row>
                    <Col style={svcLabelRowStyle} onMouseEnter={() => setHoveredField('stop_miles')}
                        onMouseLeave={() => setHoveredField(null)}>
                        <Form.Item
                            name="stop_miles" className="custom-form-item">
                            <div
                                className="RefNumbersStyle"
                                style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                            >
                                <span className={svcLabelClass}>Miles</span>
                                {hoveredField === 'stop_miles' && (
                                    <InfoTooltip
                                        label="Miles"
                                        message={[
                                            "Miles is the estimated distance for this stop. It factors into routing and can be customized per leg."
                                        ]}
                                    />
                                )}
                            </div>
                            <ReusableInput
                                data-testid="miles-input"
                                value={location?.stop_miles}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/[^0-9]/g, '');
                                    handleOnChangeDirect("stop_miles", value)
                                }}
                                type="number"
                                onKeyDown={(e) => {
                                    if (!/[0-9]/.test(e.key) &&
                                        !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                disabled={disableEditLHOrder}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
        );

        const onHandFieldCol = showOnHandFields && ["PICKUP", "DELIVERY"].includes(location?.type_of_loc) && (
            <Col span={orderTypeConfig.code === "MS" ? 6 : 12} {...(orderTypeConfig.code === "MS" ? MultiStopGridSizes : gridSizes)} className="table-col-address marginTop8">
                <Row>
                    <Col style={svcLabelRowStyle}>
                        <Form.Item className="custom-form-item">
                            <div
                                className="RefNumbersStyle"
                                style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
                            >
                                <span className={svcLabelClass}>
                                    {location.type_of_loc === "PICKUP"
                                        ? I18n.t("general.on_hand_at_origin")
                                        : I18n.t("general.on_hand_at_destination")}
                                </span>
                            </div>
                            <Row gutter={8}>
                                <Col span={14}>
                                    <ReusableDatePicker
                                        data-testid="on-hand-date-picker"
                                        format={AppConfig.dateFormat}
                                        value={location?.on_hand_datetime ? moment(location.on_hand_datetime) : null}
                                        onChange={(date) => {
                                            if (!date) {
                                                handleOnChangeDirect("on_hand_datetime", "");
                                                return;
                                            }
                                            const existing = location?.on_hand_datetime ? moment(location.on_hand_datetime) : null;
                                            const timePart = existing?.isValid() ? existing.format("HH:mm") : "00:00";
                                            handleOnChangeDirect("on_hand_datetime", `${date.format("YYYY-MM-DD")} ${timePart}`);
                                        }}
                                        disabled={disableEditLHOrder && !showOnHandFields}
                                        disabledDate={(current) => {
                                            if (location.type_of_loc !== "DELIVERY" || !current) return false;
                                            const pickupOnHand = (orderResponse?.locations || []).find((loc) => loc.type_of_loc === "PICKUP")?.on_hand_datetime;
                                            return pickupOnHand ? current.isBefore(moment(pickupOnHand), "day") : false;
                                        }}
                                    />
                                </Col>
                                <Col span={10}>
                                    <TimePicker
                                        data-testid="on-hand-time-picker"
                                        style={{ width: "100%" }}
                                        format={timeFormat}
                                        use12Hours={!isMilitaryTime}
                                        value={location?.on_hand_datetime ? moment(location.on_hand_datetime) : null}
                                        onChange={(time) => {
                                            if (!time) {
                                                const existing = location?.on_hand_datetime ? moment(location.on_hand_datetime) : null;
                                                if (!existing?.isValid()) {
                                                    handleOnChangeDirect("on_hand_datetime", "");
                                                    return;
                                                }
                                                handleOnChangeDirect("on_hand_datetime", `${existing.format("YYYY-MM-DD")} 00:00`);
                                                return;
                                            }
                                            const existing = location?.on_hand_datetime ? moment(location.on_hand_datetime) : null;
                                            const datePart = existing?.isValid() ? existing.format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
                                            handleOnChangeDirect("on_hand_datetime", `${datePart} ${time.format("HH:mm")}`);
                                        }}
                                        disabled={disableEditLHOrder && !showOnHandFields}
                                    />
                                </Col>
                            </Row>
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
        );

        const milesAndOnHandRow = (milesFieldCol || onHandFieldCol) && (
            <Row gutter={[24, 0]} className="marginTop8">
                {milesFieldCol}
                {onHandFieldCol}
            </Row>
        );

        const nonNoneLos = (levelOfServices || []).filter(item => item?.code !== "NONE");
        const noneLosItems = (levelOfServices || []).filter(item => item?.code === "NONE");
        const sortedLos = [...nonNoneLos, ...noneLosItems];

        const losOptions = sortedLos.map((item) => ({
            ...item,
            name_string: item.name,
            name: (
              <Tooltip title={`${item.name} (${item.code})`}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  <span
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      flex: 1,
                    }}
                  >
                    {item.name}
                  </span>
                  <span style={{ flexShrink: 0}}>
                    ({item.code})
                  </span>
                </div>
              </Tooltip>
            ),
          }));

        
        return (
            <>
                {showV2SvcHeader && <ServiceDetailsV2 readOnly={actionType === "view"} />}
                <div className={useV2SvcLabels ? "lp-v3 sdv2-fields" : undefined}>
                <Row gutter={[24, 0]} className="marginTop8">
                    { (orgSettings?.individual_stop_los_order_level =="true" || orderTypeConfig.code !== "MS") && <Col xs={24} sm={12} md={8} lg={6} xl={4} span={orderTypeConfig.code === "MS" ? 6 : 12} {...(orderTypeConfig.code === "MS" ? MultiStopGridSizes : gridSizes)} className="table-col-address">
                    <Row>
                            <Col style={svcLabelRowStyle} onMouseEnter={() => setHoveredField('level Of service')}
                                onMouseLeave={() => setHoveredField(null)}>
                                <Form.Item
                                    className={`${isRequired ? "required-star-right" : ""} custom-form-item`}
                                    name="los_code"
                                    key={`${locObj.loc_order_sequence}_${locObj.label_code}_los_code`}
                                >
                                    <div
                                        className="RefNumbersStyle"
                                        style={{  cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                                    >
                                        <span className={`${svcLabelClass} ${isRequired ? "require-star-right" : ""}`} >{I18n.t('general.level_of_service')}</span>
                                        {hoveredField === 'level Of service' && (
                                            <InfoTooltip
                                                label={I18n.t('general.level_of_service')}
                                                message={[
                                                    `${I18n.t('general.level_of_service')} defines the type of service provided to an account and is tied to a configured rate. Selecting a ${I18n.t('general.level_of_service')} establishes both the applicable rate and the expectations for the service being delivered.`
                                                ]}
                                            />
                                        )}
                                    </div>

                                    {/* REVIEWER NOTE — why this looks like a big change:
                                        Previously getFieldDecorator wrapped the <Select_v2> directly, keyed on
                                        los_code. That worked only while the dropdown's value WAS los_code.
                                        This feature makes the dropdown value the LOS *id* (valueField="id") so
                                        two same-code tariffs (account "TT" vs Standard "TT") are distinguishable
                                        — but getFieldDecorator injects its own value/onChange keyed on los_code,
                                        which then conflicts with an id-valued Select.

                                        Fix (same pattern as AccountBlockV2): split the two responsibilities —
                                          1. getFieldDecorator wraps a hidden input that holds los_code purely so
                                             the "required" validation still fires on submit;
                                          2. the visible <Select_v2> below is standalone (id-valued for display)
                                             and writes los_code back into this field via form.setFieldsValue.
                                        The field name stays per-leg unique
                                        (`${loc_order_sequence}_${label_code}_los_code`, as before), so multiple
                                        locations each validate independently — no collision. The large diff is
                                        just the Select moving out of the decorator, not new behavior. */}
                                    {getFieldDecorator(`${locObj.loc_order_sequence}_${locObj.label_code}_los_code`, {
                                        rules: [
                                            // Combo SL: a non-combo (combo-locked) leg shows "Rated via
                                            // Combo" and has no user-selectable tariff — its los_code is
                                            // forced to NONE server-side. It must NOT be required, or the
                                            // form blocks order creation on a leg the user can't fill.
                                            { required: isRequired && !comboLegLocked, message: `Please select ${I18n.t('general.level_of_service_small')}` },
                                        ],
                                        initialValue: comboLegLocked ? 'NONE' : location?.los_code,
                                    })(
                                        <input type="hidden" />
                                    )}
                                    {/* Task 5: combo SL non-combo leg lock. When this location's leg is
                                        locked out by the combo derivation, show a disabled "Rated via
                                        Combo" control instead of the editable tariff Select — the combo
                                        leg itself (comboLegLocked=false) still renders the normal Select
                                        below. The backend already forces the non-combo leg's los_code to
                                        NONE regardless of what's shown here. */}
                                    {comboLegLocked ? (
                                        <ReusableInput
                                            data-testid="los-dropdown-combo-locked"
                                            value={I18n.t("service_levels.rated_via_combo")}
                                            disabled
                                        />
                                    ) : (
                                    <Select_v2
                                        data-testid="los-dropdown"
                                        labelField="name"
                                        valueField="id"
                                        groupField="los_group"
                                        disabled={disableLosEdit}
                                        onChange={(value, option) => {
                                            // valueField is the LOS id (unique even when two sheets share a
                                            // code) — used only for the visible selection. The backend resolves
                                            // from los_code + rate_sheet_id (the picked option's sheet; blank =
                                            // account scope); los_id is kept in state for the dropdown/edit but
                                            // is NOT sent. los_code stays the mandatory value.
                                            const code = option?.code ?? value;
                                            handleOnChangeDirect("los_code", code);
                                            handleOnChangeDirect("los_id", option?.id ?? value);
                                            handleOnChangeDirect("rate_sheet_id", option?.rate_sheet_id || "");
                                            setIsLosCodeChanged(true);
                                            form.setFieldsValue({ [`${locObj.loc_order_sequence}_${locObj.label_code}_los_code`]: code });
                                        }}
                                        options={losOptions}
                                        placeholder="--Select--"
                                        showSelectOption={true}
                                        // Drive the visible value by id: honor an explicit los_id override
                                        // only while it's still consistent with los_code; otherwise derive
                                        // the id from los_code (so the los_code-setting effects keep the
                                        // dropdown populated, defaulting to the account's LOS on a collision).
                                        value={(() => {
                                            // Two tariffs can share a code across sheets (account vs org Standard).
                                            // When the leg has a los_id it resolves precisely (below). On the
                                            // derived/default paths (los_code set, no los_id) disambiguate by the
                                            // leg's rate_sheet_id — the same key the backend resolves with — so the
                                            // correct sheet's option is shown; only fall back to the first same-code
                                            // match when nothing disambiguates (unchanged behavior).
                                            const byCode =
                                                losOptions.find((o) => o.code === location?.los_code && (o.rate_sheet_id || "") === (location?.rate_sheet_id || "")) ||
                                                losOptions.find((o) => o.code === location?.los_code);
                                            const idMatchesCode = location?.los_id && losOptions.some((o) => o.id === location.los_id && o.code === location?.los_code);
                                            return idMatchesCode ? location.los_id : (byCode?.id || location?.los_code || undefined);
                                        })()}
                                        suffixIcon={useV2SvcLabels ? <ServiceDetailsSelectArrow /> : undefined}
                                        filterOption={(input, option) => {
                                            const matchingOption = losOptions.find((opt) => opt.id === option.props.value);
                                            if (!matchingOption) return false;
                                            const nameStr = matchingOption.name_string || "";
                                            const codeStr = matchingOption.code || "";
                                            return nameStr.toLowerCase().includes(input.toLowerCase()) ||
                                                   codeStr.toLowerCase().includes(input.toLowerCase());
                                        }}
                                    />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    }
                    <Col span={orderTypeConfig.code === "MS" ? 6 : 12} {...(orderTypeConfig.code === "MS" ? MultiStopGridSizes : gridSizes)} className="table-col-address">
                        <Row >
                            <Col style={svcLabelRowStyle} onMouseEnter={() => setHoveredField('service_duration')}
                                onMouseLeave={() => setHoveredField(null)}>
                                <Form.Item
                                    name="service_duration" className="custom-form-item">
                                    <div
                                        className="RefNumbersStyle"
                                        style={{  cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                                    >
                                        <span className={svcLabelClass} >Service Duration</span>
                                        {hoveredField === 'service_duration' && (
                                            <InfoTooltip
                                                label="Service Duration"
                                                message={[
                                                    "Service Duration is the estimated time required to complete a pickup or delivery upon arrival at the corresponding leg of an order. It factors into total route times and can be customized through default settings."
                                                ]}
                                            />
                                        )}
                                    </div>

                                    <ReusableInput
                                        data-testid="duration-input"
                                        value={location?.service_duration}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/[^0-9]/g, '');
                                            handleOnChangeDirect("service_duration", value)
                                        }}
                                        type="number"
                                        onKeyDown={(e) => {
                                            // Allow only numbers, backspace, delete, tab, arrows
                                            if (!/[0-9]/.test(e.key) && 
                                                !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        suffix="min"
                                        disabled={disableEditLHOrder}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>

                    {orderTypeConfig?.code === "MS" && (
                        <AppointmentWindow
                            labelCode={getLabelForAppointments()}
                            location={location}
                            handleOnChange={handleOnChange}
                            availableDatesInfo={availableDatesInfo}
                            hasDeliveryZipcodesConfig={hasDeliveryZipcodesConfig}
                            handleAppointmentTimeChange={handleAppointmentTimeChange}
                            options={options}
                            gridSizes={gridSizes}
                            MultiStopGridSizes={MultiStopGridSizes}
                            appointmentTime={appointmentTime ? `${appointmentTime.start_time}-${appointmentTime.end_time}` : ''}
                            multiStop={orderTypeConfig?.code}
                            appointmentStyle={props.appointmentStyle}
                            isCreateOrder={actionType === "create"}
                            disableEditLHOrder={disableEditLHOrder}
                            useV2Label={useV2SvcLabels}
                            afterTimeCol={null}
                            getFieldDecorator={getFieldDecorator}
                            form={form}
                        />
                    )}
                  {/* {["MS"].includes(orderTypeConfig.code)&& <Col span={6}{...MultiStopGridSizes} className="table-col-address">
                        <Row >
                            <Col style={{ lineHeight: "30px", }} onMouseEnter={() => setHoveredField('stop_miles')}
                                onMouseLeave={() => setHoveredField(null)}>
                                <Form.Item
                                    name="stop_miles" className="custom-form-item">
                                    <div
                                        className="RefNumbersStyle"
                                        style={{  cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                                    >
                                        <span className="heading-3-large" >Miles</span>
                                        {hoveredField === 'stop_miles' && (
                                            <InfoTooltip
                                                label="Miles"
                                                message={[
                                                    "Miles is the estimated time required to complete a pickup or delivery upon arrival at the corresponding leg of an order. It factors into total route times and can be customized through default settings."
                                                ]}
                                            />
                                        )}
                                    </div>
                                    <ReusableInput
                                        value={location?.stop_miles}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/[^0-9]/g, '');
                                            handleOnChangeDirect("stop_miles", value)
                                        }}
                                        type="number"
                                        onKeyDown={(e) => {
                                            // Allow only numbers, backspace, delete, tab, arrows
                                            if (!/[0-9]/.test(e.key) && 
                                                !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>} */}
                </Row>
                {orderTypeConfig?.code !== "MS" && (
                  <Fragment>
                    <AppointmentWindow
                        labelCode={getLabelForAppointments()}
                        location={location}
                        handleOnChange={handleOnChange}
                        availableDatesInfo={availableDatesInfo}
                        hasDeliveryZipcodesConfig={hasDeliveryZipcodesConfig}
                        handleAppointmentTimeChange={handleAppointmentTimeChange}
                        options={options}
                        gridSizes={gridSizes}
                        MultiStopGridSizes={MultiStopGridSizes}
                        appointmentTime={appointmentTime ? `${appointmentTime.start_time}-${appointmentTime.end_time}` : ''}
                        multiStop={orderTypeConfig?.code}
                        allowAppointment={allowAppointment}
                        isCreateOrder={actionType === "create"}
                        disableEditLHOrder={disableEditLHOrder}
                        useV2Label={useV2SvcLabels}
                        afterTimeCol={null}
                        getFieldDecorator={getFieldDecorator}
                        form={form}
                    />
                    {milesAndOnHandRow}
                    {currentPreplan?.delivery_start_date &&
                      <Row type='flex' align="middle" className="marginTop10">
                        <Col className="appointment-preplan-chip" data-testid="display-time">
                          <PreplanIcon width="12" height="12" color="#576EC1" />
                          <span>Preplan: {" "}
                            <DisplayTime
                              dateTimeString={currentPreplan.delivery_start_date}
                              displayWithDate={true}
                              timeFormat={AppConfig.dateFormat}
                              timeZoneId={currentPreplan.timeZoneId}
                            /> - {" "}
                            <DisplayTime
                              dateTimeString={currentPreplan.delivery_end_date}
                              displayWithDate={true}
                              timeFormat={AppConfig.dateFormat}
                              timeZoneId={currentPreplan.timeZoneId}
                            />
                          </span>
                          <ChevronRightIcon width="12" height="12" color="#576EC1" />
                        </Col>
                      </Row>
                    }
                    </Fragment>

                )}
                {hideNonCdkAppointment && actionType === "update" &&  (
                  <Fragment> 
                    <>
                    <Col span={12}  className="table-col right-adjustment">
                   <Form.Item
                   name="received"
                   label={location.type_of_loc === "PICKUP" ? "Picked Up" : location.type_of_loc === "DELIVERY"? "Received (CDK)": null}
                   className="custom-form-item">
                   
                <DatePicker
                  data-testid="received-date-picker"
                  onChange={(date, dateString) => {
                    if (date) {
                      const timePart = location.actual_start_datetime
                        ? moment(location.actual_start_datetime).format("HH:mm:ss")
                        : "00:00:00";
                
                      const combinedDateTime = moment(`${dateString} ${timePart}`).format("YYYY-MM-DD HH:mm:ss");
                
                      handleOnChangeDirect("actual_start_datetime", combinedDateTime);
                    } else {
                      handleOnChangeDirect("actual_start_datetime", "");
                    }
                  }}
                  style={{ width: "100%" }}
                  value={
                    location.actual_start_datetime
                      ? moment(location.actual_start_datetime)
                      : null
                  }
                  format={AppConfig.dateFormat}
                  // disabledDate={(current) => {                  
                  //   if (keyToBeUsed === "pickupBy" || keyToBeUsed === "deliveryBy") {
                  //     return targetDate
                  //       ? current && current.isBefore(targetDate, "day") 
                  //       : false;
                  //   }else if (keyToBeUsed === "received") {
                  //    const pickupByDate = this.props.currentOrder?.customer_order_details.pickup_by;
                  //    const deliveryByDate = this.props.currentOrder?.customer_order_details.delivery_by;
                  //      const earliestDate = pickupByDate && deliveryByDate
                  //      ? moment.min(moment(pickupByDate), moment(deliveryByDate))
                  //      : pickupByDate || deliveryByDate;
                  //      return earliestDate ? current && current.isAfter(moment(earliestDate), "day") : false;
                  //   }
                  //   return false;
                  // }}
                />
                </Form.Item>
                    </Col>
              <Col span={12} className="table-col-address down-adjustment left-adjustment">
              <Form.Item
                   name="received_time"
                   className="custom-form-item">
               
                <TimePicker
                  data-testid="received-time-picker"
                  onChange={(time, timeString) => {
                    if (time) {
                      const datePart = location.actual_start_datetime
                        ? moment(location.actual_start_datetime).format("YYYY-MM-DD")
                        : moment().format("YYYY-MM-DD");
                
                      const combinedDateTime = moment(`${datePart} ${timeString}`).format("YYYY-MM-DD HH:mm:ss");
                
                      handleOnChangeDirect("actual_start_datetime", combinedDateTime);
                    } else {
                      handleOnChangeDirect("actual_start_datetime", "");
                    }
                  }}
                  style={{ width: "100%" }}
                  defaultOpenValue={moment(isMilitaryTime ? "00:00" : "00:00 AM", timeFormat)}
                  value={
                    location.actual_start_datetime
                      ? moment(location.actual_start_datetime)
                      : null
                  }
                  format={timeFormat}
                  use12Hours={!isMilitaryTime}
                />
                </Form.Item>
              </Col>
              
            </>
                  </Fragment>

                )}
                </div>
            {/* MS renders ServiceOptionsV2 inside MultistopOrder.jsx's top
                header (next to the Pickup/Delivery tabs) — skip the bottom
                render here to avoid duplication. */}
            {!checkIsCrossDockLocation() && orderTypeConfig?.code !== "MS" && (
              <Row className="marginTop10">
                <Col span={24}>
                  <ServiceOptionsV2
                    location={location}
                    typeOfLoc={locObj.type_of_loc}
                    labelCode={location.label_code}
                    orderTypeCode={orderTypeConfig.code}
                    disabled={disableEditLHOrder}
                    isOrgSpecific={isOrgSpecific}
                    showAppointment={showAppointmentCheckbox}
                    onChangeDirect={handleOnChangeDirect}
                    onChangeNested={handleOnChange}
                  />
                </Col>
              </Row>
            )}
            </>
        );
    };

    const rendeCrossDockOrderForm = () => {
      const isDisabled = samaAsOther && orderTypeConfig.code === "CDK" && locObj.label_code === "R";
      return (
        <CrossDockFormV2
          location={location}
          onChangeDirect={handleOnChangeDirect}
          onSelect={onSelectForCrossDock}
          orderTypeConfig={orderTypeConfig}
          selectedWarehouseId={selectedWarehouse}
          disabled={isDisabled}
        />
      );
    };

    // const renderNonCrossDockOrderForm = () => (
    //     <Form className="address-form marginBottom10" ref={formRef}>
    //         <AddressForm_v2
    //             location={location}
    //             onAddressSelect={onAddressSelect}
    //             handleOnChangeDirect={handleOnChangeDirect} 
    //             handleOnChangeAddress={handleOnChangeAddress}
    //            // form={form}
    //            // getFieldDecorator={getFieldDecorator}
    //         />
    //     </Form>
    // );

    const generateOrderCombinedCode = () => {
        const resolvedCode = orderTypeConfig?.extraCode || orderTypeConfig.code;
        return `${resolvedCode}-${locObj?.label_code || ""}`;
    };

    const checkIsCrossDockLocation = () => {
        const combinedCode = generateOrderCombinedCode();
        const crossDockCodes = ["CDK-DRPF", "CDK-R", "PCDK-CDK", "CDKD-CDK", "WO-R", "WO-DRPF"];

        if (_.includes(orderTypeConfig.code, "CDK") || _.includes(orderTypeConfig.code, "WO")) {
            return _.includes(crossDockCodes, combinedCode);
        }

        return false;
    };

    const clearAddress = () => {
        setTempLocation({
          ...tempLocation,
          ...(actionType === 'create' ? {customer_country: 'USA'} : {})
        })
        setLocation(
          _.omit(location, [
            "company_name",
            "customer_email",
            "customer_address_line_1",
            "customer_address_line_2",
            "customer_city",
            "customer_state",
            "customer_country",
            "customer_zipcode",
            "address_type",
            "operational_use",
            "secondary_loc_type",
            "customer_phone_one",
            "customer_phone_two",
            "customer_first_name",
            "l_type",
            // collapsed-summary metadata — clear so a re-picked/emptied leg
            // doesn't retain the previous predefined location's details.
            "start_time",
            "end_time",
            "location_code",
            "location_name",
            "notes",
          ])
        );
        if(location.type_of_loc === "PICKUP"){
          setOriginCode(currentWhCode || selectedWarehouse?.location_code)
        } else if(location.type_of_loc === "DELIVERY"){
          setDestinationCode(currentWhCode || selectedWarehouse?.location_code)
        }
    }

    const ConsigneeDetailsForm = () => {

        const format_l_address = (selectedAddress) =>
            selectedAddress
                ? [
                    selectedAddress.customer_address_line_1 || "",
                    selectedAddress.customer_address_line_2 || "",
                    selectedAddress.customer_city || "",
                    selectedAddress.customer_state || "",
                    selectedAddress.customer_zipcode || "",
                    selectedAddress.customer_country || ""
                  ]
                    .filter(Boolean)
                    .join(", ")
                : "";

        const formattedAddress = removeUnnecessaryCommas(
            format_l_address(location)
        );

        return (
          <DisableWrapper disabled={disableEditLHOrder}>
            <div className="address_shown" data-testid="address-details-show">
              <Row type="flex" justify="space-between">
                <Col span={20}>
                  <Row>
                    <Col>
                      <Text className="fontWeight600 ">
                        {config?.show_only_company_name === "true"
                          ? (location?.company_name || formatFullName(location, "customer_first_name", "customer_last_name") || "N/A")
                          : formatLocationName(location, "customer_first_name", "customer_last_name", (orgSettings?.prioritize_company_in_location === "true"))}
                      </Text>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Tooltip title={formattedAddress}>
                        <Text type="secondary">
                          {formattedAddress}
                          {/* {ellipseText(formattedAddress, 50)} */}
                        </Text>
                      </Tooltip>
                    </Col>
                  </Row>
                  <Row type="flex" gutter={16}>
                    <Col style={{ paddingLeft: 5, display: "flex", gap: "5px" }}>
                      <img src={CommercialIcon} alt="" />
                      <span className="details-text">
                        {formamtAddressType(location?.address_type, emptyText)}
                      </span>
                    </Col>
                    <Col style={{ paddingLeft: 5, display: "flex", gap: "5px" }}>
                      <img src={MailIcon} alt="" />
                      <span className="details-text">
                        {location?.customer_email || emptyText}
                      </span>
                    </Col>

                  </Row>
                  <Row type="flex" gutter={8}>
                    <Col style={{ paddingLeft: "0px" }}>
                      <div style={{ display: "flex", gap: "5px" }}>
                        <img src={LocCodeIcon} alt="" />
                        <span className="details-text">
                          {location?.acc_loc_code || emptyText}
                        </span>
                      </div>
                      <div style={{ display: "flex", gap: "5px" }}>
                        <img src={PhoneIcon} alt="" />
                        <span className="details-text">
                          {location?.customer_phone_one || location?.customer_phone_two
                            ? [
                              location.customer_phone_one,
                              location.customer_phone_two
                            ]
                              .filter(Boolean) // Remove undefined/null values
                              .map(num => num.startsWith("+") ? num : `+${num}`) // Ensure only one `+` removes duplicate + values
                              .join(", ")
                            : emptyText}
                        </span>

                      </div>
                    </Col>
                  </Row>
                </Col>
                {!(
                  (orderTypeConfig.code === 'LH' || orderTypeConfig.code === 'NLH' || orderTypeConfig.code === 'LHD') && locObj.label_code === "ORN"
                ) && (
                    <Col span={4} style={{ textAlign: "end" }}>
                      <Tooltip title="Edit">
                        <img
                          data-testid="edit-address-button"
                          className="cursorPointer"
                          onClick={() => {
                            setEditClicked(true);
                            setShowAddAddressModal(true);
                          }}
                          src={EditPen}
                        />
                      </Tooltip>
                      <Tooltip title="Clear">
                        <img
                          data-testid="clear-address-button"
                          className="cursorPointer"
                          onClick={() => clearAddress()}
                          src={closeSvg}
                        />
                      </Tooltip>
                    </Col>
                  )}
              </Row>
            </div>
          </DisableWrapper>
        );
    };

    // service_levels relocated the Special/Form/Signature/Expedite service-option
    // checkboxes into the dedicated ServiceOptionsV2 section (rendered below), so
    // this node stays the simple cross-dock "Same Company as Dropoff" checkbox
    // only. (master's version rendered those options inline in the header — kept
    // out here to avoid duplicating ServiceOptionsV2.)
    const extraActionNodeFun = () => {
        if (!checkIsCrossDockLocation()) return null;
        if (location.label_code !== 'R') return null;
        return (
          <Row type="flex" gutter={10}>
            <Col data-testid="drop-off-checkbox">
              <Checkbox_v2
                handleChange={(val) => setSamaAsOther(val)}
                label={`Same Company as Dropoff`}
                checkValue={samaAsOther}
              />
            </Col>
          </Row>
        );
    };

    const sectionTitleFun = () => {
        return (
            <Row type="flex" gutter={10} align="middle">
                <Col>
                    {getOrderTypeIconForLocation(generateOrderCombinedCode(), {
                        height: "24",
                        width: "24",
                    })}
                </Col>
                <Col>
                    <span className="location_heading">
                    {/* DB-driven order types (service_level_flow_enabled): the move type's
                        leg_name ("Shipper Pickup") rides in on the catalog-built config.
                        Legacy configs never set leg_name, so the label_code switch below
                        keeps rendering exactly as before when the flag is off. */}
                    {locObj?.leg_name || getLabelDescriptionForLocation(locObj.label_code, orderTypeConfig?.extraCode || orderTypeConfig?.code)}
                    {(locObj?.label_code === "DST" || locObj?.label_code === "ORN") && (orderTypeConfig?.code === "PLH" || orderTypeConfig?.code === "LHD") && ` (${I18n.t("general.warehouse")})`}
                  </span>
                </Col>
            </Row>
        );
    };


    const gridSizes = gridSize
        ? gridSize
        : {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 12,
            xl: 12,
        };

    const validatePhoneNumber = (phone) => {
      const phoneWithoutCountryCode = String(phone || "").replace(/[^0-9]/g, "");
      if (!phoneWithoutCountryCode) return false;
      return [10, 11, 12].includes(phoneWithoutCountryCode.length);
    };

    const validateEmail = (email) => {
      if (!email) return true; // Allow empty email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };

    const validateAddressFields = (tempLoc, isEditMode = false) => {
      const errors = [];

      // In edit mode, combine existing location with temp changes
      const locToValidate = isEditMode ? { ...location, ...tempLoc } : tempLoc;

      // Validate predefined fields when saving as predefined
      if (locToValidate?.is_predefined) {
        if (!locToValidate?.location_name?.trim()) {
          errors.push("Name is required.");
        }
        if (!locToValidate?.location_code?.trim()) {
          errors.push("Code is required.");
        }
      }

      // Validate required fields
     if(orgSettings?.company_name_mandatory == "true" && !locToValidate?.company_name?.trim()){
        errors.push("Company Name is required.");
     }

      if (!locToValidate?.customer_address_line_1?.trim()) {
        errors.push("Address Line 1 is required.");
      }

      if (!locToValidate?.customer_city?.trim()) {
        errors.push("City is required.");
      }

      if (!locToValidate?.customer_state?.trim()) {
        errors.push("State is required.");
      }

      if (!locToValidate?.customer_zipcode?.trim()) {
        errors.push("Zipcode is required.");
      }

      if (!locToValidate?.customer_country?.trim()) {
        errors.push("Country is required.");
      }

      const isPhone1Required = !!locToValidate?.is_predefined;
      if (isPhone1Required && !locToValidate?.customer_phone_one?.trim()) {
        errors.push("Phone 1 is required.");
      } else if (
        locToValidate?.customer_phone_one?.trim() &&
        !validatePhoneNumber(locToValidate?.customer_phone_one)
      ) {
        errors.push("Phone 1 is invalid. Please enter a valid phone number.");
      }
      
      // if (locToValidate?.customer_phone_two && !validatePhoneNumber(locToValidate?.customer_phone_two)) {
      //   errors.push("Phone 2 is invalid. Please enter a valid phone number.");
      // }
      
      if (locToValidate?.customer_email && !validateEmail(locToValidate?.customer_email)) {
        errors.push("Please enter a valid email address.");
      }

      if (locToValidate?.appointment?.has_expedite || (isOrgSpecific && locToValidate?.appointment?.has_appointment)) {
        if (!locToValidate?.appointment?.appt_date) {
          errors.push(`${getLabelForAppointments()} is required.`);
        }
        if (!locToValidate?.appointment?.start_time || !locToValidate?.appointment?.end_time) {
          errors.push("Time Window Slot is required.");
        }
      }
      
      return errors;
    };

    const handleModalSave = () => {

      // validate company name 

      const companyNameCheck = validateCompanyName([tempLocation]);
      
     if (companyNameCheck.length > 0 && orgSettings?.company_name_mandatory == "true") {
       companyNameCheck.forEach(val => renderNotification(val, "error"));
       return;
     }   

      const errors = validateAddressFields({ ...location, ...tempLocation }, editClicked);
      if (errors.length > 0) {
        const uniqueErrors = [...new Set(errors)];
        renderNotification(
          <div>
            {uniqueErrors.map((error, index) => (
              <div key={`${index}-${error}`}>{error}</div>
            ))}
          </div>,
          "error"
        );
        return;
      }

      if (editClicked) {
        // In edit mode, merge temp changes with existing location
        setLocation(prev => ({ ...prev, ...tempLocation }));
        verifyWhZipCodes(tempLocation?.customer_zipcode || location?.customer_zipcode, location?.type_of_loc);
        setLocation(prev => {
          setStateChanged({ prev_zipcode: true });
          return ({ ...prev, ...tempLocation })
        });
      } else {
        // For new address, use temp location directly
      setLocation(prev => ({
        ...prev,
        ...tempLocation,
        // Ensure required fields are present
        customer_address_line_1: tempLocation.customer_address_line_1 || '',
        customer_address_line_2: tempLocation.customer_address_line_2 || '',
        customer_city: tempLocation.customer_city || '',
        customer_state: tempLocation.customer_state || '',
        customer_country: tempLocation.customer_country || '',
        customer_zipcode: tempLocation.customer_zipcode || '',
        operational_use: tempLocation.operational_use || "FINAL_MILE",
      }));
      }
      if (hasCompleteAddress({ ...location, ...tempLocation })) {
        setAddressCollapsed(true);
        focusNextEditable();
      }
      setShowAddAddressModal(false);
      setTempLocation({});
    };

    const handleModalChangeDirect = (key, value) => {
      if (["customer_phone_one", "customer_phone_two"].includes(key)) {
        const phoneWithoutCountryCode = String(value || "").replace(/[^0-9]/g, '');
        const isValid = !phoneWithoutCountryCode || [10, 11, 12].includes(phoneWithoutCountryCode.length);
        if (!isValid) {
          setTempLocation((prevLocation) => ({
            ...prevLocation,
            [key]: value,
            phoneError: true,
          }));
        } else {
          setTempLocation((prevLocation) => ({
            ...prevLocation,
            [key]: value,
            phoneError: '',
          }));
        }
      } else {
        setTempLocation((prevLocation) => {
          setStateChanged({ prev_zipcode: true });
          return {
          ...prevLocation,
          [key]: value,
          }
        });
      }
    };

    const handleModalChangeAddress = (selectedAddress) => {
      if (!selectedAddress || typeof selectedAddress !== "string") {
        console.error("Invalid address provided");
        return;
      }
      
      let addressArray = selectedAddress.split(",");
      const output = {
        zipcode: "",
        country: "",
        state: "",
        city: "",
        address_line2: "",
        address_line1: "",
      };
      const address_line1 = addressArray.splice(0, 1).join(", ");
      addressArray = addressArray.reverse();
      for (let i = 0; i < addressArray.length; i++) {
        output[Object.keys(output)[i]] = addressArray[i];
      }
      output.address_line1 = addressArray.length > 5
        ? `${address_line1}, ${addressArray.slice(5).reverse().join(", ")}`
        : address_line1;

      setTempLocation(prev => ({
        ...prev,
        customer_address_line_1: output?.address_line1 || '',
        customer_address_line_2: output?.address_line2 || '',
        customer_city: output?.city || "",
        customer_state: output?.state || "",
        customer_country: output?.country || "",
        customer_zipcode: output?.zipcode || "",
      }));
    };

    const handleModalAddressSelect = (selectedAddress) => {
      if(!selectedAddress){
        return;
      }
      if (selectedAddress.type == "web") {
        setEditClicked(true);
      }
      if (["LH", "NLH", "PLH", "PLHD"].includes(orderTypeConfig.code) && locObj.type_of_loc === "DELIVERY") {
        setTargetWarehouse(selectedAddress.id)
      }

      setTempLocation(prev => ({
        ...prev,
        company_name: selectedAddress.type === 'predefined' ? selectedAddress.company_name : selectedAddress.company_name,
        customer_email: selectedAddress.type === 'predefined' ? selectedAddress.email : selectedAddress.email,
        customer_address_line_1: selectedAddress?.l_address?.address_line1 || '',
        customer_address_line_2: selectedAddress?.l_address?.address_line2 || '',
        customer_city: selectedAddress?.l_address?.city || "",
        customer_state: selectedAddress?.l_address?.state || "",
        customer_country: selectedAddress?.l_address?.country || "",
        customer_zipcode: selectedAddress?.l_address?.zipcode || "",
        address_type: selectedAddress?.l_address?.address_type || selectedAddress?.address_type || accountConfig?.default_location_type || "COMMERCIAL",
        operational_use: selectedAddress?.operational_use || "FINAL_MILE",
        secondary_loc_type: normalizeSecondaryLocType(selectedAddress?.secondary_loc_type),
        customer_phone_one: selectedAddress.type === 'predefined' ? selectedAddress.phone : selectedAddress.phone,
        customer_phone_two: selectedAddress.type === 'predefined' ? selectedAddress.phone_2 : selectedAddress.phone_2,
        customer_first_name: selectedAddress.type === 'predefined' ? selectedAddress.first_name : "",
        customer_last_name: selectedAddress.type === 'predefined' ? selectedAddress.last_name : "",
        l_type: (orderTypeConfig.code === 'LH'||orderTypeConfig.code === 'NLH'|| orderTypeConfig.code === 'LHD') && locObj.type_of_loc === "PICKUP" ? 'WH' : getLocationType(orderTypeConfig, locType, selectedAddress),
        label_code: locObj.label_code,
        type_of_loc: locType
      }));

      if (selectedAddress?.l_address?.zipcode) {
        verifyZipcode(selectedAddress.l_address.zipcode, location?.type_of_loc)
        verifyWhZipCodes(selectedAddress.l_address.zipcode, location?.type_of_loc)
        getAvailableDates(selectedAddress.l_address.zipcode)
      }
    };
    
    const renderAddAddressModal = () => {
      return (
        <Modal
          className="address-details-modal"
          title={editClicked ? "Edit Address" : "Add Address"}
          destroyOnClose={editClicked ? true: false}
          centered
          closable={!renderModalActions ? true : false}
          maskClosable={false}
          visible={showAddAddressModal}
          onCancel={() => {
            setShowAddAddressModal(false);
            setEditClicked(false);
            setTempLocation({});
          }}
          onOk={() => {
            setShowAddAddressModal(false);
            setEditClicked(false);
          }}
          width={544}
          footer={
            <div style={{ display: "flex", flexDirection: "column", padding: "0px 16px" }}>
              <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                <Row type="flex" justify="end"  data-testid="predefiend-location-checkbox">
                  <Col>
                    <Button_v2
                      data-testid="cancel-address-button"
                      onClick={() => {
                        setShowAddAddressModal(false);
                        setTempLocation({});
                        setEditClicked(false);
                      }}
                      className="flat medium-btn"
                      text="Cancel"
                    />
                    <Button_v2
                      data-testid={`${editClicked ? "update-address" : "add-address"}-button`}
                      onClick={handleModalSave}
                      className="raised medium-btn"
                      text={editClicked ? "Update Address" : "Add Address"}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          }
        >
          <AddAddressForm
            accountConfig={accountConfig}
            location={editClicked ? { ...location, ...tempLocation } : tempLocation}
            onAddressSelect={handleModalAddressSelect}
            handleOnChangeDirect={handleModalChangeDirect}
            handleOnChangeAddress={handleModalChangeAddress}
            isMilitaryTime={isMilitaryTime}
            showSearch={editClicked ? true : false}
            showPredefinedFields={false}
            getAvailableDates={getAvailableDates}
            verifyZipcode={verifyZipcode}
            linehaul_code={isLinehaulCode}
            linehaul_label={isDstOrOrn}
            hideWebResults={isDstOrOrn}
            disableAddressFields={isDstOrOrn || false}
            verifyWhZipCodes={verifyWhZipCodes}
            tempLocation={tempLocation}
            selectedWarehouseId={selectedWarehouse}
            orderTypeConfig={orderTypeConfig}
          />
        </Modal>
      );
    };

        const renderZipWhSelectionModal = () => {
      return (
        <>
      { warningText && <Modal
          className="address-details-modal"
          title={""}
          destroyOnClose={showWarningWhModal ? true: false}
          centered
          closable={false}
          maskClosable={false}
          visible={showWarningWhModal && warningText}
          width={600}
          footer={
            <div style={{ display: "flex", flexDirection: "column", padding: "0px 16px" }}>
              <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                <Row type="flex" justify="end">
                  <Col>
                    <Button_v2
                      onClick={() => {
                        setWarningWhModal(false);
                        setWhZipCodeData([]);
                        setRenderModalActions(false);
                        setWarningText("");
                        setShowAddAddressModal(true);
                        setEditClicked(true);
                        setSelectedWarehouseId(selectedWarehouseId)
                      }}
                      className="flat medium-btn"
                      text="Cancel"
                    />
                    <Button_v2
                       onClick={() => {
                        ProceedSelection()
                      }}
                      className="raised medium-btn"
                      text={"Proceed"}
                      disabled={selectedWarehouseId ? false : true}
                      loading={inProgress}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          }
        >
        <ZipCodeWhModal
        type={locObj && _.get(locObj, "type_of_loc", null)}
        warehouses={whZipCodeData}
        setSelectedWarehouseId={setSelectedWarehouseId}
        setDeliveryWarehouseID={setDeliveryWarehouseID}
        selectedWarehouseId={selectedWarehouseId}
        warningText={warningText}
        />
        </Modal>}
        </>
      );
    };

    const renderAccessorial = (labelCodeTitle) => {
        return (<CreateOrderAccessorial
            // getDataRef={accessorialRef.current[index]}
            accountComponentAccessorial={accountComponentAccessorial}
            config={props.config}
            haveMultipleLocations={props.haveMultipleLocations}
            displayComponents={props?.displayComponents || []}
            title={labelCodeTitle}
            //accRef={accessorialRef}
            drivers={dtiversData}
            updateOrderAccessorials={(newAccs, callback, errorCallback, finalCallback) => {
              setOrderAccessorials(newAccs);
              const hadAppt = (orderAccessorials || []).some(
                (acc) => acc.accessorial_code === "APPT"
              );
              const hasApptNow = (newAccs || []).some(
                (acc) => acc.accessorial_code === "APPT"
              );
              let updatedAppointment = location?.appointment;
              if (hadAppt && !hasApptNow && location?.appointment?.has_appointment) {
                handleOnChange("has_appointment", "appointment", false);
                updatedAppointment = {
                  ...location?.appointment,
                  has_appointment: false,
                };
              }
              if (props.handleLocationUpdate) {
                props.handleLocationUpdate({
                  ...locObj,
                  appointment: updatedAppointment,
                  accessorials: newAccs,
                });
              }
              if (callback) callback();
            }}
            processingRecords={orderAccessorials}
            currentOrg={currentOrg}
            accountId={currentAccount.id}
            prevAuthorizedInfo={authorizeDetails}
            actionType={actionType}
            showActions={!(["PLH", "LHD"].includes(orderTypeConfig?.code) && isDstOrOrn)}
            
        />)
    }
    // const title = sectionTitleFun()
    const title = MultiStop ? sectionTitleFun() : ""
    const extraAction = MultiStop ? extraActionNodeFun() : null
    const labelCodeTitle = getLabelDescriptionForLocation(locObj.label_code, orderTypeConfig?.extraCode || orderTypeConfig?.code);
    // const blockGridSize = props.showSidebySide ? 12 : 24
    const blockGridSize = props.showSidebySide && MultiStop ? 12 : 24
    const DELIVERY_ORDER_TYPES = ["SDR", "SDD", "MDR", "MDD", "M", 'LH',"LHD","NLH","PLH","PLHD","APAD"];
    const isMultiStopOrder = orderTypeConfig?.code === "MS";
    const isDeliveryOrder = DELIVERY_ORDER_TYPES.includes(orderTypeConfig?.code);
    const isFirstLocation = location?.loc_order_sequence < 1;
    
    const isRequired = isMultiStopOrder 
      ? !isFirstLocation ? checkIsFilled(location, ["address_type"]) : true
      : location?.loc_order_sequence > 0 && !isDeliveryOrder ? checkIsFilled(location, ["address_type"]) : true


    const multiStopFields = () => {
      return (
        <Row gutter={actionType === 'view' ? [16, 16] : [24, 0]}>
          {/* total weight in lbs */}
          <Col
            span={actionType === 'view' ? 8 : 4}
            onMouseEnter={() => setHoveredField("weight")}
            onMouseLeave={() => setHoveredField(null)}
          >
            <Form.Item
              name="weight"
              style={{ marginBottom: actionType === 'view' && 0 }}
              // className={`${isRequired ? "required-star-right" : ""} custom-form-item`}
            >
              <div
                className="RefNumbersStyle"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {/* <span className={`heading-3-large ${isRequired ? "require-star-right" : ""}`} >Total Weight</span> */}
                <span className={`heading-3-large`}>Stop Level Weight</span>
                {hoveredField === "weight" && (
                  <InfoTooltip
                    label="Total Weight"
                    message={[
                      "The Total Weight field displays the combined weight of all items in an order, shown in both pounds (lbs) and kilograms (kgs). While this value can be entered manually, it is automatically overridden when items are added to the order, reflecting their combined weights.Total weight is a critical factor during planning and routing, as it influences whether an order can be assigned to a route without exceeding the vehicle's maximum weight capacity.",
                    ]}
                  />
                )}
              </div>
              <ReusableInput
              data-testid="weight-level-input"
                value={location?.weight}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  handleOnChangeDirect("weight", value);
                }}
                type="number"
                onKeyDown={(e) => {
                  // Allow only numbers, backspace, delete, tab, arrows
                  if (
                    !/[0-9]/.test(e.key) &&
                    ![
                      "Backspace",
                      "Delete",
                      "Tab",
                      "ArrowLeft",
                      "ArrowRight",
                      "ArrowUp",
                      "ArrowDown",
                    ].includes(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
                suffix="lbs"
              />
            </Form.Item>
          </Col>
          {/* total weight in KGs */}
          <Col
            span={actionType === 'view' ? 8 : 4}
            onMouseEnter={() => setHoveredField("weight")}
            onMouseLeave={() => setHoveredField(null)}
          >
            <Form.Item
              name="weight"
              style={{ marginBottom: actionType === 'view' && 0 }}
              // className={`${isRequired ? "required-star-right" : ""} custom-form-item`}
            >
              <div
                className="RefNumbersStyle"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {/* <span className={`heading-3-large ${isRequired ? "require-star-right" : ""}`} >Total Weight</span> */}
                <span className={`heading-3-large`}>Weight in Kgs</span>
                {hoveredField === "weight" && (
                  <InfoTooltip
                    label="Total Weight"
                    message={[
                      "The Total Weight field displays the combined weight of all items in an order, shown in both pounds (lbs) and kilograms (kgs). While this value can be entered manually, it is automatically overridden when items are added to the order, reflecting their combined weights.Total weight is a critical factor during planning and routing, as it influences whether an order can be assigned to a route without exceeding the vehicle's maximum weight capacity.",
                    ]}
                  />
                )}
              </div>
              <ReusableInput
                data-testid="weight-in-kgs-input"
                value={(location?.weight * 0.453592) || null}
                onChange={(e) => {
                  const value = e.target.value; 
                  if (value) {
                    const weightInLbs = (parseFloat(value) / 0.453592); 
                    handleOnChangeDirect("weight", weightInLbs); 
                  } else {
                    handleOnChangeDirect("weight", ""); 
                  }
                }}
                type="number"
                onKeyDown={(e) => {
                  if (
                    !/[0-9]/.test(e.key) &&
                    ![
                      "Backspace",
                      "Delete",
                      "Tab",
                      "ArrowLeft",
                      "ArrowRight",
                      "ArrowUp",
                      "ArrowDown",
                    ].includes(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
                suffix="Kgs"
              />
            </Form.Item>
          </Col>
          <Col
            span={actionType === 'view' ? 8 : 4}
            onMouseEnter={() => setHoveredField("quantity")}
            onMouseLeave={() => setHoveredField(null)}
          >
            <Form.Item
            style={{ marginBottom: actionType === 'view' && 0 }}
            // className={`${isRequired ? "required-star-right" : ""} custom-form-item`}
            >
              <div
                className="RefNumbersStyle"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span className={`heading-3-large`}>Quantity</span>
                {hoveredField === "quantity" && (
                  <InfoTooltip
                    label="Quantity"
                    message={[
                      "The Quantity field indicates the total number of items included in the order. This value can be manually entered but is overridden when items are added, reflecting their combined count.While quantity does not affect preplanning, it provides an expectation for dispatch and drivers regarding the volume of items being picked up or delivered.",
                    ]}
                  />
                )}
              </div>
              <ReusableInput
                data-testid="quantity-input"
                value={location?.quantity}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  handleOnChangeDirect("quantity", value);
                }}
                type="number"
                onKeyDown={(e) => {
                  // Allow only numbers, backspace, delete, tab, arrows
                  if (
                    !/[0-9]/.test(e.key) &&
                    ![
                      "Backspace",
                      "Delete",
                      "Tab",
                      "ArrowLeft",
                      "ArrowRight",
                      "ArrowUp",
                      "ArrowDown",
                    ].includes(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
                // suffix="min"
              />
            </Form.Item>
          </Col>
          <Col
            span={actionType === 'view' ? 12 : 6}
            onMouseEnter={() => setHoveredField("pallets")}
            onMouseLeave={() => setHoveredField(null)}
          >
            <Form.Item
            style={{ marginBottom: actionType === 'view' && 0 }}
            // className={`${isRequired ? "required-star-right" : ""} custom-form-item`}
            >
              <div
                className="RefNumbersStyle"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span className={`heading-3-large`}>Skids/Pallets</span>
                {hoveredField === "pallets" && (
                  <InfoTooltip
                    label="Skids/Pallets"
                    message={[
                      ` ${I18n.t('general.level_of_service')} defines the type of service provided to an account and is tied to a configured rate. Selecting a ${I18n.t('general.level_of_service')} establishes both the applicable rate and the expectations for the service being delivered.`,
                    ]}
                  />
                )}
              </div>
              <ReusableInput
                data-testid="skids-pallets-input"
                value={location?.pallets}
                onChange={(e) => {
                  const value = e.target.value;
                  handleOnChangeDirect("pallets", value);
                }}
                type="number"
                onKeyDown={(e) => {
                  // Allow only numbers, backspace, delete, tab, arrows
                  if (
                    !/[0-9]/.test(e.key) &&
                    ![
                      "Backspace",
                      "Delete",
                      "Tab",
                      "ArrowLeft",
                      "ArrowRight",
                      "ArrowUp",
                      "ArrowDown",
                    ].includes(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
                // suffix="min"
              />
            </Form.Item>
          </Col>
          <Col
            span={actionType === 'view' ? 12 : 6}
            onMouseEnter={() => setHoveredField("surface_area")}
            onMouseLeave={() => setHoveredField(null)}
          >
            <Form.Item
            style={{ marginBottom: actionType === 'view' && 0 }}
            // className={`${isRequired ? "required-star-right" : ""} custom-form-item`}
            >
              <div
                className="RefNumbersStyle"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span className={`heading-3-large`}>Surf. Area (in²)</span>
                {hoveredField === "surface_area" && (
                  <InfoTooltip
                    label="Surf.Area(in²)"
                    message={[
                      ` ${I18n.t('general.level_of_service')} defines the type of service provided to an account and is tied to a configured rate. Selecting a ${I18n.t('general.level_of_service')} establishes both the applicable rate and the expectations for the service being delivered.`,
                    ]}
                  />
                )}
              </div>
              <ReusableInput
                data-testid="surf-area-input"
                value={location?.surface_area}
                onChange={(e) => {
                  const value = e.target.value;
                  handleOnChangeDirect("surface_area", value);
                }}
                type="number"
                // onKeyDown={(e) => {
                // // Allow only numbers, backspace, delete, tab, arrows
                // if (!/[0-9]/.test(e.key) &&
                // !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
                // e.preventDefault();
                // }
                // }}
                suffix= "in²"
              />
            </Form.Item>
          </Col>
        </Row>
      );
    };
      
    const renderCollapsedAddressCard = () => {
      const addressLine = removeUnnecessaryCommas(
        [
          location.customer_address_line_1,
          location.customer_address_line_2,
          location.customer_city,
          location.customer_state,
          location.customer_zipcode,
          location.customer_country,
        ].filter(Boolean).join(", ")
      );
      const displayName =
        location.company_name ||
        [location.customer_first_name, location.customer_last_name].filter(Boolean).join(" ") ||
        emptyText;
      const clearAddress = () => {
        setLocation((prev) => ({
          ...prev,
          company_name: "",
          customer_email: "",
          customer_address_line_1: "",
          customer_address_line_2: "",
          customer_city: "",
          customer_state: "",
          customer_country: "",
          customer_zipcode: "",
          customer_phone_one: "",
          customer_phone_two: "",
          customer_first_name: "",
          customer_last_name: "",
          start_time: "",
          end_time: "",
          location_code: "",
          location_name: "",
        }));
        setAddressCollapsed(false);
      };
      const contactName = [location.customer_first_name, location.customer_last_name].filter(Boolean).join(" ");
      // Operating hours are HH:mm strings on the (predefined) location record.
      const fmtOpTime = (t) => {
        if (!t) return "";
        const m = moment(t, ["HH:mm", "H:mm", "hh:mm A", "h:mm A", "HH:mm:ss"]);
        return m.isValid() ? m.format("h:mmA") : "";
      };
      const operationalHours = location.start_time && location.end_time
        ? `${fmtOpTime(location.start_time)} - ${fmtOpTime(location.end_time)}`
        : "";
      // Linehaul: show this leg's warehouse (FEWH, EXPINTL, etc.), not order-level
      // warehouse_id which tracks current hub after stops complete (e.g. AUSTIN).
      let warehouseCode = selectedWarehouse?.code || selectedWarehouse?.location_code || "";
      if (isLinehaulCode) {
        const legWhId = location?.warehouse_id
          || (locObj.type_of_loc === "DELIVERY" ? deliveryWarehouseID : null);
        const legWh = legWhId ? _.find(warehouses, { id: legWhId }) : null;
        warehouseCode =
          location?.location_code
          || legWh?.location_code
          || legWh?.code
          || (isNew && locObj.type_of_loc === "PICKUP" ? warehouseCode : "");
      }
      // Always render the field with its icon; fall back to a muted "N/A" when
      // empty so the summary shows a consistent, aligned set of details
      // (industry-standard placeholder rather than a blank/collapsed cell). The
      // value truncates with an ellipsis and a tooltip carries the label + full
      // value (icons alone aren't self-explanatory, and values can overflow).
      const detailItem = (icon, value, label) => (
        <Tooltip title={`${label}: ${value || "N/A"}`}>
          <span style={{ display: "inline-flex", alignItems: "center", gap: 4, maxWidth: "100%" }}>
            <CardGlyph name={icon} />
            <span
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                ...(value ? {} : { color: "#A6AEBD" }),
              }}
            >
              {value || "N/A"}
            </span>
          </span>
        </Tooltip>
      );
      // Fixed left|right pair per row (50/50, no column gap) so the columns
      // always align — matches Figma (each row 20px tall, stacked with no gap).
      const detailRow = (leftIcon, leftVal, leftLabel, rightIcon, rightVal, rightLabel) => (
        <div style={{ display: "flex", minHeight: 20, lineHeight: "20px" }}>
          <div style={{ flex: "1 1 0", minWidth: 0 }}>{detailItem(leftIcon, leftVal, leftLabel)}</div>
          <div style={{ flex: "1 1 0", minWidth: 0 }}>{detailItem(rightIcon, rightVal, rightLabel)}</div>
        </div>
      );
      {/* Suppress Edit/Clear when the order is locked (disableEditLHOrder) and for the
          LH/NLH/LHD origin (ORN) leg, which is the auto-selected terminal/warehouse and
          was never editable/clearable in the pre-refactor flow. Restores the guards that
          the old ConsigneeDetailsForm/DisableWrapper enforced. */}
      const showEditControls =
        !disableEditLHOrder &&
        !(["LH", "NLH", "LHD"].includes(orderTypeConfig?.code) && locObj?.label_code === "ORN");

      return (
        <div
          data-testid={`collapsed-address-${locObj.type_of_loc}`}
          style={{ background: "#EEF2FB", borderRadius: 10, padding: "12px 16px", marginBottom: 12 }}
        >
          {/* Header: company/contact name + warehouse code + edit/clear controls, all
              inline so the code never sits under the action icons. */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
            <span style={{ fontWeight: 700, color: "#273156", fontSize: 14 }}>{displayName}</span>
            <div style={{ display: "flex", alignItems: "center", gap: 12, flexShrink: 0 }}>
              {warehouseCode ? <span style={{ fontWeight: 700, color: "#C3CBDA", fontSize: 16, letterSpacing: 0.5 }}>{warehouseCode}</span> : null}
              {showEditControls && (
                <>
                  <img src={EditPen} alt="edit address" title="Edit address" style={{ width: 16, cursor: "pointer" }}
                       data-testid="collapsed-address-edit" onClick={() => setAddressCollapsed(false)} />
                  <img src={closeSvg} alt="clear address" title="Clear address" style={{ width: 13, cursor: "pointer" }}
                       data-testid="collapsed-address-clear" onClick={clearAddress} />
                </>
              )}
            </div>
          </div>
          {/* Address type + predefined location code */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: 16, marginTop: 4, color: "#4B5563" }}>
            {detailItem("building", formamtAddressType(location.address_type || "COMMERCIAL"), "Address type")}
            {location.location_code ? detailItem("pin", `Location Code: ${location.location_code}`, "Location code") : null}
          </div>
          {addressLine ? <div style={{ color: "#3E5CCB", marginTop: 8, fontWeight: 600 }}>{addressLine}</div> : null}
          {/* Row-paired details, aligned 50/50 with no row/column gap to match Figma:
              contact|email, phone|phone2, operational-hours|notes. */}
          <div style={{ display: "flex", flexDirection: "column", marginTop: 8, color: "#4B5563" }}>
            {detailRow("user", contactName, "Contact name", "mail", location.customer_email, "Email")}
            {detailRow("phone", location.customer_phone_one, "Phone", "phone", location.customer_phone_two, "Alternate phone")}
            {detailRow("clock", operationalHours, "Operational hours", "note", location.notes, "Notes")}
          </div>
        </div>
      );
    };

    return (
        <Row gutter={[16, 16]}>
            <Col md={blockGridSize} data-testid={`location-type-${locObj.type_of_loc}`}>
                <SectionCard
                    title={title ? title : undefined}
            extraActionNode={extraAction}
                >

                  {orderTypeConfig.code === "MS" && (
                   <div>
                      {multiStopFields()}
                    </div>
                   )}
                    { actionType === 'view' && (<>&nbsp;</>)}
                    <div className="address_location_innerContainer table-col" ref={legBodyRef}>
                        {/* {!editClicked && */}
                        {!checkIsCrossDockLocation() && addressCollapsed && renderCollapsedAddressCard()}
                        {!checkIsCrossDockLocation() && !addressCollapsed && (
                          // display:contents wrapper — pure event/ref host for the
                          // focus-out-to-collapse logic; adds no box so AddressV2's
                          // layout is unchanged.
                          <div ref={addressBlockRef} onBlur={handleAddressBlockBlur} style={{ display: "contents" }}>
                          <AddressV2
                            location={location}
                            onChangeDirect={handleOnChangeDirect}
                            onAddressSelect={onAddressSelect}
                            orderTypeConfig={orderTypeConfig}
                            selectedWarehouseId={selectedWarehouse}
                            isLinehaulCode={isLinehaulCode}
                            isDstOrOrn={isDstOrOrn}
                            disabled={disableEditLHOrder}
                            orgId={currentOrg?.id}
                            isMilitaryTime={isMilitaryTime}
                            onSaveModalToggle={(open) => { suppressBlurCollapseRef.current = open; }}
                          />
                          </div>
                        )}
                        {/* } */}
                        {/* {!editClicked && (
          <Form.Item
          label="Location Code "
          colon={false}
          className={`table-col custom-form-item marginTop8`}
          name="acc_loc_code"
          key={`${locObj.label_code}_location_code`}
          >
          <ReusableInput
          name="acc_loc_code"
          value={location?.acc_loc_code}
          onChange={(e) =>
            handleOnChangeDirect("acc_loc_code", e.target.value)
            }
            />
            </Form.Item>
            )} */}

                        {renderAddAddressModal()}

                        {renderZipWhSelectionModal()}

                        {checkIsCrossDockLocation() && rendeCrossDockOrderForm()}

                        {restDetailsFun(isRequired)}
                    </div>
                </SectionCard>
            </Col>
            {props.showAccessorial && MultiStop && (
                <Col md={blockGridSize} xs={24} data-testid={`accessorial-block-${labelCodeTitle}`}>
                    <div>{renderAccessorial(labelCodeTitle)}</div>
                </Col>
            )}
        </Row>
    );
};

AddressLocationDetails.propTypes = {
    handleUpdateWhStorage: PropTypes.func,
  };
AddressLocationDetails.defaultProps = {
    handleUpdateWhStorage: () => {},
};
  

export default AddressLocationDetails;
